import * as d from "react";
import { p as v, g as mn } from "./index-efd35e77.js";
import { w as j, x as N } from "./index-93802845.js";
import { B as Re } from "./Button-4c83e316.js";
import { v as gn, w as yn, x as bn, y as _n, z as On, A as En, B as wn, C as xn, D as Cn, E as Sn, F as In, G as Un, H as Fn, I as kn, J as Rn, l as Tn, K as jn, L as An } from "./index.es-6889c727.js";
import { P as Bt } from "./ProgressBar-f33eeff2.js";
import { l as Dn, v as Pn } from "./index-64063129.js";
var Mn = !!// from fbjs
(typeof window < "u" && window.document && window.document.createElement), C = function() {
  for (var n = [], r = 0; r < arguments.length; r++)
    n[r] = arguments[r];
  var t = {}, e = function(a) {
    return typeof a == "object" ? Object.keys(a).forEach(function(i) {
      t[i] = a[i];
    }) : t[a] = !0;
  }, o = function(a) {
    return a.filter(function(i) {
      return i !== !0 && !!i;
    }).map(function(i) {
      return Array.isArray(i) ? o(i) : e(i);
    });
  };
  return o(n), Object.keys(t).map(function(a) {
    return t[a] && a || null;
  }).filter(function(a) {
    return a !== null;
  }).join(" ");
}, Nn = -1, Bn = 0, Ln = function(n, r, t) {
  var e = typeof n == "string" ? parseInt(n, void 0) : n;
  if (e !== NaN)
    return e !== void 0 ? e : r ? t ? void 0 : Nn : Bn;
}, ft = function() {
  var n = "", r, t;
  for (r = 0; r < 32; r++)
    t = Math.random() * 16 | 0, (r === 8 || r === 12 || r === 16 || r === 20) && (n += "-"), n += (r === 12 ? 4 : r === 16 ? t & 3 | 8 : t).toString(16);
  return n;
}, D = {
  backspace: 8,
  tab: 9,
  enter: 13,
  shift: 16,
  esc: 27,
  space: 32,
  pageUp: 33,
  pageDown: 34,
  end: 35,
  home: 36,
  left: 37,
  up: 38,
  right: 39,
  down: 40,
  delete: 46
};
function qn(n) {
  if (typeof Dn < "u")
    Pn(n);
  else {
    var r = "License activation failed for ".concat(n.name, `
`);
    r += `The @progress/kendo-licensing script is not loaded.
`, r += "See ".concat(n.licensingDocsUrl, ` for more information.
`), console.warn(r);
  }
}
var zn = function(n, r, t) {
  t === void 0 && (t = {});
  var e = d.useCallback(function(p) {
    t.onMouseDown && t.onMouseDown.call(void 0, p), n.onMouseDown && n.onMouseDown.call(void 0, {
      target: r.current,
      syntheticEvent: p
    });
  }, [t.onMouseDown, n.onMouseDown, r]), o = d.useCallback(function(p) {
    t.onMouseUp && t.onMouseUp.call(void 0, p), n.onMouseUp && n.onMouseUp.call(void 0, {
      target: r.current,
      syntheticEvent: p
    });
  }, [t.onMouseUp, n.onMouseUp, r]), a = d.useCallback(function(p) {
    t.onClick && t.onClick.call(void 0, p), n.onClick && n.onClick.call(void 0, {
      target: r.current,
      syntheticEvent: p
    });
  }, [t.onClick, n.onClick, r]), i = d.useCallback(function(p) {
    t.onDoubleClick && t.onDoubleClick.call(void 0, p), n.onDoubleClick && n.onDoubleClick.call(void 0, {
      target: r.current,
      syntheticEvent: p
    });
  }, [t.onDoubleClick, n.onDoubleClick, r]), s = d.useCallback(function(p) {
    t.onMouseEnter && t.onMouseEnter.call(void 0, p), n.onMouseEnter && n.onMouseEnter.call(void 0, {
      target: r.current,
      syntheticEvent: p
    });
  }, [t.onMouseEnter, n.onMouseEnter, r]), u = d.useCallback(function(p) {
    t.onMouseLeave && t.onMouseLeave.call(void 0, p), n.onMouseLeave && n.onMouseLeave.call(void 0, {
      target: r.current,
      syntheticEvent: p
    });
  }, [t.onMouseLeave, n.onMouseLeave, r]), l = d.useCallback(function(p) {
    t.onMouseMove && t.onMouseMove.call(void 0, p), n.onMouseMove && n.onMouseMove.call(void 0, {
      target: r.current,
      syntheticEvent: p
    });
  }, [t.onMouseMove, n.onMouseMove, r]), f = d.useCallback(function(p) {
    t.onMouseOut && t.onMouseOut.call(void 0, p), n.onMouseOut && n.onMouseOut.call(void 0, {
      target: r.current,
      syntheticEvent: p
    });
  }, [t.onMouseOut, n.onMouseOut, r]), c = d.useCallback(function(p) {
    t.onMouseOver && t.onMouseOver.call(void 0, p), n.onMouseOver && n.onMouseOver.call(void 0, {
      target: r.current,
      syntheticEvent: p
    });
  }, [t.onMouseOver, n.onMouseOver, r]);
  return {
    onClick: a,
    onMouseUp: o,
    onMouseDown: e,
    onDoubleClick: i,
    onMouseEnter: s,
    onMouseLeave: u,
    onMouseMove: l,
    onMouseOut: f,
    onMouseOver: c
  };
}, Lt = {
  default: "",
  xsmall: "k-icon-xs",
  small: "k-icon-sm",
  medium: "k-icon-md",
  large: "k-icon-lg",
  xlarge: "k-icon-xl",
  xxlarge: "k-icon-xxl",
  xxxlarge: "k-icon-xxxl"
}, Te = globalThis && globalThis.__assign || function() {
  return Te = Object.assign || function(n) {
    for (var r, t = 1, e = arguments.length; t < e; t++) {
      r = arguments[t];
      for (var o in r)
        Object.prototype.hasOwnProperty.call(r, o) && (n[o] = r[o]);
    }
    return n;
  }, Te.apply(this, arguments);
}, $n = globalThis && globalThis.__rest || function(n, r) {
  var t = {};
  for (var e in n)
    Object.prototype.hasOwnProperty.call(n, e) && r.indexOf(e) < 0 && (t[e] = n[e]);
  if (n != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, e = Object.getOwnPropertySymbols(n); o < e.length; o++)
      r.indexOf(e[o]) < 0 && Object.prototype.propertyIsEnumerable.call(n, e[o]) && (t[e[o]] = n[e[o]]);
  return t;
}, et = d.forwardRef(function(n, r) {
  var t = n.className, e = n.name, o = n.themeColor, a = n.size, i = n.flip, s = n.style, u = n.id, l = n.tabIndex, f = $n(n, ["className", "name", "themeColor", "size", "flip", "style", "id", "tabIndex"]), c = d.useRef(null), p = d.useRef(null);
  d.useImperativeHandle(c, function() {
    return {
      element: p.current
    };
  }), d.useImperativeHandle(r, function() {
    return c.current;
  });
  var h = d.useMemo(function() {
    return a || dt.size;
  }, [a]), m = d.useMemo(function() {
    return i || dt.flip;
  }, [i]), x = d.useMemo(function() {
    var O;
    return C("k-icon", "k-font-icon", e && Kn(e), (O = {}, O["k-color-".concat(o)] = o, O["k-flip-h"] = m === "horizontal" || m === "both", O["k-flip-v"] = m === "vertical" || m === "both", O), Lt[h], t);
  }, [e, o, h, m, t]), w = zn(n, c);
  return d.createElement("span", Te({ ref: p }, f, w, { className: x, id: u, tabIndex: l, style: s, role: "presentation" }));
});
et.propTypes = {
  style: v.object,
  classNames: v.string,
  name: v.string,
  themeColor: v.oneOf([
    "inherit",
    "primary",
    "secondary",
    "tertiary",
    "info",
    "success",
    "error",
    "warning",
    "dark",
    "light",
    "inverse"
  ]),
  size: v.oneOf(["default", "xsmall", "small", "medium", "large", "xlarge", "xxlarge", "xxxlarge"]),
  flip: v.oneOf(["default", "horizontal", "vertical", "both"])
};
var dt = {
  size: "default",
  flip: "default"
};
et.displayName = "KendoIcon";
var z = globalThis && globalThis.__assign || function() {
  return z = Object.assign || function(n) {
    for (var r, t = 1, e = arguments.length; t < e; t++) {
      r = arguments[t];
      for (var o in r)
        Object.prototype.hasOwnProperty.call(r, o) && (n[o] = r[o]);
    }
    return n;
  }, z.apply(this, arguments);
}, Hn = globalThis && globalThis.__rest || function(n, r) {
  var t = {};
  for (var e in n)
    Object.prototype.hasOwnProperty.call(n, e) && r.indexOf(e) < 0 && (t[e] = n[e]);
  if (n != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, e = Object.getOwnPropertySymbols(n); o < e.length; o++)
      r.indexOf(e[o]) < 0 && Object.prototype.propertyIsEnumerable.call(n, e[o]) && (t[e[o]] = n[e[o]]);
  return t;
}, tt = d.forwardRef(function(n, r) {
  var t = n.children, e = n.className, o = n.svgClassName, a = n.icon, i = n.flip, s = n.id, u = n.tabIndex, l = n.size, f = n.style, c = n.svgStyle, p = n.themeColor, h = n.viewBox;
  n.name;
  var m = n.onClick, x = Hn(n, ["children", "className", "svgClassName", "icon", "flip", "id", "tabIndex", "size", "style", "svgStyle", "themeColor", "viewBox", "name", "onClick"]), w = d.useRef(null);
  d.useImperativeHandle(r, function() {
    return {
      element: w.current
    };
  });
  var O = d.useMemo(function() {
    return a ? a.name : Y.icon;
  }, [a]), S = d.useMemo(function() {
    return l || Y.size;
  }, [l]), k = d.useMemo(function() {
    return i || Y.flip;
  }, [i]), g = d.useMemo(function() {
    return h || Y.viewBox;
  }, [h]), B = d.useMemo(function() {
    var M;
    return C("k-icon", "k-svg-icon", "k-svg-i-" + O, (M = {}, M["k-color-".concat(p)] = p, M["k-flip-h"] = k === "horizontal" || k === "both", M["k-flip-v"] = k === "vertical" || k === "both", M), Lt[S], e);
  }, [O, p, S, k, e]), ue = d.useMemo(function() {
    return n.width && n.height ? z({ width: n.width, height: n.height }, f) : n.width ? z({ width: n.width, height: n.width }, f) : n.height ? z({ width: n.height, height: n.height }, f) : z({}, f);
  }, [n.width, n.height, f]);
  return d.createElement(
    "span",
    { className: B, style: ue, ref: w, onClick: m },
    d.createElement("svg", z({ id: s, className: o, style: c, "aria-hidden": !0, tabIndex: u, focusable: !1, xmlns: "http://www.w3.org/2000/svg", viewBox: a ? a.viewBox : g, dangerouslySetInnerHTML: a ? { __html: a.content } : void 0 }, x), a ? void 0 : t)
  );
});
tt.propTypes = {
  style: v.object,
  classNames: v.string,
  children: v.any,
  icon: v.object,
  themeColor: v.oneOf([
    "inherit",
    "primary",
    "secondary",
    "tertiary",
    "info",
    "success",
    "error",
    "warning",
    "dark",
    "light",
    "inverse"
  ]),
  size: v.oneOf(["default", "xsmall", "small", "medium", "large", "xlarge", "xxlarge", "xxxlarge"]),
  flip: v.oneOf(["default", "horizontal", "vertical", "both"])
};
var Y = {
  size: "default",
  flip: "default",
  icon: "",
  viewBox: "0 0 24 24"
};
tt.displayName = "KendoSvgIcon";
var qt = d.createContext({ type: "svg" });
qt.displayName = "KendoReactIconsContext";
var te = globalThis && globalThis.__assign || function() {
  return te = Object.assign || function(n) {
    for (var r, t = 1, e = arguments.length; t < e; t++) {
      r = arguments[t];
      for (var o in r)
        Object.prototype.hasOwnProperty.call(r, o) && (n[o] = r[o]);
    }
    return n;
  }, te.apply(this, arguments);
}, Vn = globalThis && globalThis.__rest || function(n, r) {
  var t = {};
  for (var e in n)
    Object.prototype.hasOwnProperty.call(n, e) && r.indexOf(e) < 0 && (t[e] = n[e]);
  if (n != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, e = Object.getOwnPropertySymbols(n); o < e.length; o++)
      r.indexOf(e[o]) < 0 && Object.prototype.propertyIsEnumerable.call(n, e[o]) && (t[e[o]] = n[e[o]]);
  return t;
}, re = d.forwardRef(function(n, r) {
  var t, e, o = d.useContext(qt), a = o.type, i = o.icons, s = n.icon, u = Vn(n, ["icon"]), l = a === "svg" ? ((t = n.icon) === null || t === void 0 ? void 0 : t.name) || n.name : n.name || ((e = n.icon) === null || e === void 0 ? void 0 : e.name);
  l = l && i && i[l] && typeof i[l] == "string" ? i[l] : l;
  var f = l && i && i[l] && typeof i[l] != "string" ? i[l] : s;
  return a === "svg" && f ? d.createElement(tt, te({}, n, { icon: f, ref: r })) : d.createElement(et, te({}, u, { name: l, ref: r }));
});
re.displayName = "KendoIconWrap";
var Kn = function(n) {
  return "k-i-" + n;
};
v.shape({
  name: v.string.isRequired,
  content: v.string.isRequired,
  viewBox: v.string.isRequired
});
var je = function(n) {
  var r = n.shadowRoot, t = n.contentDocument;
  return r && r.activeElement ? je(r.activeElement) : t && t.activeElement ? je(t.activeElement) : n;
}, zt = function(n) {
  if (!(!n || !n.activeElement))
    return je(n.activeElement);
}, y;
(function(n) {
  n[n.UploadFailed = 0] = "UploadFailed", n[n.Initial = 1] = "Initial", n[n.Selected = 2] = "Selected", n[n.Uploading = 3] = "Uploading", n[n.Uploaded = 4] = "Uploaded", n[n.RemoveFailed = 5] = "RemoveFailed", n[n.Removing = 6] = "Removing";
})(y || (y = {}));
var b, Ae = "upload.cancel", De = "upload.clearSelectedFiles", Pe = "upload.dropFilesHere", Me = "upload.headerStatusUploaded", Ne = "upload.headerStatusUploading", Gn = "upload.invalidFileExtension", Jn = "upload.invalidFiles", Xn = "upload.invalidMaxFileSize", Zn = "upload.invalidMinFileSize", Be = "upload.remove", Le = "upload.retry", J = "upload.select", $t = "upload.selectTitle", Ht = "upload.selectNoFilesTitle", qe = "upload.uploadSelectedFiles", ze = "upload.total", $e = "upload.files", X = "upload.statusUploaded", Z = "upload.statusUploadFailed", Wn = "upload.dropZoneHint", Yn = "upload.defaultDropZoneNote", Qn = "upload.dropZoneNote", _ = (b = {}, b[Ae] = "Cancel", b[De] = "Clear", b[Pe] = "Drop files here to upload", b[Me] = "Done", b[Ne] = "Uploading...", b[Gn] = "File type not allowed.", b[Jn] = "Invalid file(s). Please check file upload requirements.", b[Xn] = "File size too large.", b[Zn] = "File size too small.", b[Be] = "Remove", b[Le] = "Retry", b[J] = "Select files...", b[$t] = "Press to select more files", b[Ht] = "No files selected", b[qe] = "Upload", b[ze] = "Total", b[$e] = "files", b[X] = "File(s) successfully uploaded.", b[Z] = "File(s) failed to upload.", b[Wn] = "Drag and drop files here to upload.", b[Yn] = "", b[Qn] = "Only {0} files are allowed.", b), er = /&/g, tr = /</g, nr = /"/g, rr = /'/g, or = />/g, Vt = function(n) {
  return ("" + n).replace(er, "&amp;").replace(tr, "&lt;").replace(or, "&gt;").replace(nr, "&quot;").replace(rr, "&#39;");
}, Kt = function(n) {
  var r = /\.([^\.]+)$/, t = n.match(r);
  return t ? t[0] : "";
}, Gt = function(n) {
  var r = n.name, t = n.size;
  return {
    extension: Kt(r),
    name: Vt(r),
    getRawFile: function() {
      return n;
    },
    size: t,
    status: y.Selected,
    progress: 0,
    uid: ""
  };
}, ar = function(n) {
  var r = new Array(), t;
  for (t = 0; t < n.length; t++)
    r.push(Gt(n[t]));
  return r;
}, nt = function(n) {
  return !!(n.validationErrors && n.validationErrors.length > 0);
}, ir = function(n) {
  for (var r = 0, t = n; r < t.length; r++) {
    var e = t[r];
    if (nt(e))
      return !0;
  }
  return !1;
}, sr = function(n) {
  var r = 0, t;
  if (typeof n[0].size == "number")
    for (t = 0; t < n.length; t++)
      n[t].size && (r += n[t].size || 0);
  else
    return "";
  return r /= 1024, r < 1024 ? r.toFixed(2) + " KB" : (r / 1024).toFixed(2) + " MB";
}, lr = function(n, r) {
  var t = ft();
  return n.map(function(e) {
    return e.uid = r ? t : ft(), e;
  });
}, ur = function(n) {
  var r = !1, t = !1, e = !1, o = !1, a = function(i) {
    i.forEach(function(s) {
      s.status === y.Uploading && (r = !0), s.status === y.Uploaded && (t = !0), s.status === y.UploadFailed && (e = !0), nt(s) && (o = !0);
    });
  };
  return Array.isArray(n) ? a(n) : Object.keys(n).forEach(function(i) {
    a(n[i]);
  }), [r, t, e, o];
};
const T = {
  fileHasValidationErrors: nt,
  filesHaveValidationErrors: ir,
  getTotalFilesSizeMessage: sr,
  getAllFileInfo: ar,
  getFileInfo: Gt,
  getFileExtension: Kt,
  htmlEncode: Vt,
  assignGuidToFiles: lr,
  getFileStatus: ur
};
var cr = globalThis && globalThis.__extends || function() {
  var n = function(r, t) {
    return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, o) {
      e.__proto__ = o;
    } || function(e, o) {
      for (var a in o)
        Object.prototype.hasOwnProperty.call(o, a) && (e[a] = o[a]);
    }, n(r, t);
  };
  return function(r, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    n(r, t);
    function e() {
      this.constructor = r;
    }
    r.prototype = t === null ? Object.create(t) : (e.prototype = t.prototype, new e());
  };
}(), rt = (
  /** @class */
  function(n) {
    cr(r, n);
    function r(t) {
      var e = n.call(this, t) || this;
      return e.buttonClassNames = function(o) {
        var a = e.state, i = a.actionFocused, s = a.retryFocused;
        return C("k-icon-button k-upload-action", e.props.disabled ? "k-disabled" : "", i && o === "action" || s && o === "retry" ? "k-focus" : "");
      }, e.onRetryFocus = function() {
        e.setState({
          retryFocused: !0
        });
      }, e.onRetryBlur = function() {
        e.setState({
          retryFocused: !1
        });
      }, e.onActionFocus = function() {
        e.setState({
          actionFocused: !0
        });
      }, e.onActionBlur = function() {
        e.setState({
          actionFocused: !1
        });
      }, e.onActionClick = function() {
        var o = e.props, a = o.status, i = o.uid, s = o.disabled, u = o.onCancel, l = o.onRemove;
        s || a === y.Removing || (a === y.Uploading ? u.call(void 0, i) : l.call(void 0, i));
      }, e.onRetryClick = function() {
        var o = e.props, a = o.uid, i = o.disabled, s = o.onRetry;
        i || s.call(void 0, a);
      }, e.state = {
        retryFocused: !1,
        actionFocused: !1
      }, e;
    }
    return r.prototype.actionButtonTitle = function(t, e) {
      return t === y.Uploading ? e.toLanguageString(Ae, _[Ae]) : e.toLanguageString(Be, _[Be]);
    }, r.prototype.retryButtonTitle = function(t) {
      return t.toLanguageString(Le, _[Le]);
    }, r.prototype.render = function() {
      var t = this.props, e = t.status, o = t.progress, a = e === y.UploadFailed, i = e === y.Uploading, s = (e === y.Uploaded || e === y.Initial) && !this.props.async.removeUrl, u = j(this), l = "%";
      return d.createElement(
        "span",
        { className: "k-upload-actions" },
        i ? d.createElement(
          "span",
          { className: "k-upload-pct" },
          o,
          l
        ) : void 0,
        a ? d.createElement(Re, { type: "button", themeColor: "base", fillMode: "flat", tabIndex: -1, className: this.buttonClassNames("retry"), onFocus: this.onRetryFocus, onBlur: this.onRetryBlur, onClick: this.onRetryClick, "aria-label": this.retryButtonTitle(u), title: this.retryButtonTitle(u), icon: "arrow-rotate-cw-small", svgIcon: gn }) : void 0,
        s ? void 0 : d.createElement(Re, { type: "button", themeColor: "base", fillMode: "flat", tabIndex: -1, className: this.buttonClassNames("action"), onFocus: this.onActionFocus, onBlur: this.onActionBlur, onClick: this.onActionClick, "aria-label": this.actionButtonTitle(e, u), title: this.actionButtonTitle(e, u), icon: e === y.Uploading ? "cancel" : "x", svgIcon: e === y.Uploading ? yn : bn })
      );
    }, r;
  }(d.Component)
);
N(rt);
var fr = globalThis && globalThis.__extends || function() {
  var n = function(r, t) {
    return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, o) {
      e.__proto__ = o;
    } || function(e, o) {
      for (var a in o)
        Object.prototype.hasOwnProperty.call(o, a) && (e[a] = o[a]);
    }, n(r, t);
  };
  return function(r, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    n(r, t);
    function e() {
      this.constructor = r;
    }
    r.prototype = t === null ? Object.create(t) : (e.prototype = t.prototype, new e());
  };
}(), ne = globalThis && globalThis.__assign || function() {
  return ne = Object.assign || function(n) {
    for (var r, t = 1, e = arguments.length; t < e; t++) {
      r = arguments[t];
      for (var o in r)
        Object.prototype.hasOwnProperty.call(r, o) && (n[o] = r[o]);
    }
    return n;
  }, ne.apply(this, arguments);
}, dr = globalThis && globalThis.__rest || function(n, r) {
  var t = {};
  for (var e in n)
    Object.prototype.hasOwnProperty.call(n, e) && r.indexOf(e) < 0 && (t[e] = n[e]);
  if (n != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, e = Object.getOwnPropertySymbols(n); o < e.length; o++)
      r.indexOf(e[o]) < 0 && Object.prototype.propertyIsEnumerable.call(n, e[o]) && (t[e[o]] = n[e[o]]);
  return t;
}, Jt = (
  /** @class */
  function(n) {
    fr(r, n);
    function r() {
      return n !== null && n.apply(this, arguments) || this;
    }
    return r.prototype.getFileExtension = function(t) {
      return t.extension ? t.extension.substring(1) : "";
    }, r.prototype.getFileValidationMessage = function(t, e) {
      var o = j(this), a = "";
      if (e)
        a = o.toLanguageString(Z, _[Z]);
      else if (t.validationErrors && t.validationErrors.length > 0) {
        var i = "upload.".concat(t.validationErrors[0]);
        a = o.toLanguageString(i, _[i]);
      }
      return a;
    }, r.prototype.getFileExtensionIcon = function(t) {
      switch (t.extension) {
        case ".png":
        case ".jpg":
        case ".jpeg":
        case ".tiff":
        case ".bmp":
        case ".gif":
          return { name: "file-image", icon: kn };
        case ".mp3":
        case ".mp4":
        case ".wav":
          return { name: "file-audio", icon: Fn };
        case ".mkv":
        case ".webm":
        case ".flv":
        case ".gifv":
        case ".avi":
        case ".wmv":
          return { name: "file-video", icon: Un };
        case ".txt":
          return { name: "file-txt", icon: In };
        case ".pdf":
          return { name: "file-pdf", icon: Sn };
        case ".ppt":
        case ".pptx":
          return { name: "file-presentation", icon: Cn };
        case ".csv":
        case ".xls":
        case ".xlsx":
          return { name: "file-data", icon: xn };
        case ".html":
        case ".css":
        case ".js":
        case ".ts":
          return { name: "file-programming", icon: wn };
        case ".exe":
          return { name: "file-config", icon: En };
        case ".zip":
        case ".rar":
          return { name: "file-zip", icon: On };
        default:
          return { name: "file", icon: _n };
      }
    }, r.prototype.renderValidationError = function(t, e) {
      return d.createElement(
        "span",
        { className: "k-file-info", key: "2" },
        d.createElement("span", { className: "k-file-name", title: t.name }, t.name),
        d.createElement("span", { className: "k-file-validation-message" }, this.getFileValidationMessage(t, e))
      );
    }, r.prototype.renderFileDetails = function(t) {
      var e = j(this), o = e.toLanguageString(X, _[X]);
      return d.createElement(
        "span",
        { className: "k-file-info", key: "2" },
        d.createElement("span", { className: "k-file-name", title: t.name }, t.name),
        t.progress !== 100 ? d.createElement("span", { className: "k-file-size" }, T.getTotalFilesSizeMessage([t])) : d.createElement("span", { className: "k-file-validation-message" }, o)
      );
    }, r.prototype.render = function() {
      var t = this.props, e = t.files, o = dr(t, ["files"]), a = e[0], i = T.getFileStatus([a]), s = i[1], u = i[2], l = i[3], f = !l && !s && !u;
      return d.createElement(
        "div",
        { className: C("k-file-single") },
        f && d.createElement(Bt, { value: a.progress || 0 }),
        d.createElement(
          "span",
          { className: "k-file-icon-wrapper", key: "1" },
          d.createElement(re, ne({ className: "k-file-icon" }, this.getFileExtensionIcon(a), { size: "xxlarge" })),
          d.createElement("span", { className: "k-file-state" })
        ),
        l || u ? this.renderValidationError(a, u) : this.renderFileDetails(a),
        d.createElement(rt, ne({ uid: a.uid, status: a.status, progress: a.progress }, o))
      );
    }, r;
  }(d.Component)
);
N(Jt);
var pr = globalThis && globalThis.__extends || function() {
  var n = function(r, t) {
    return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, o) {
      e.__proto__ = o;
    } || function(e, o) {
      for (var a in o)
        Object.prototype.hasOwnProperty.call(o, a) && (e[a] = o[a]);
    }, n(r, t);
  };
  return function(r, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    n(r, t);
    function e() {
      this.constructor = r;
    }
    r.prototype = t === null ? Object.create(t) : (e.prototype = t.prototype, new e());
  };
}(), He = globalThis && globalThis.__assign || function() {
  return He = Object.assign || function(n) {
    for (var r, t = 1, e = arguments.length; t < e; t++) {
      r = arguments[t];
      for (var o in r)
        Object.prototype.hasOwnProperty.call(r, o) && (n[o] = r[o]);
    }
    return n;
  }, He.apply(this, arguments);
}, vr = globalThis && globalThis.__rest || function(n, r) {
  var t = {};
  for (var e in n)
    Object.prototype.hasOwnProperty.call(n, e) && r.indexOf(e) < 0 && (t[e] = n[e]);
  if (n != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, e = Object.getOwnPropertySymbols(n); o < e.length; o++)
      r.indexOf(e[o]) < 0 && Object.prototype.propertyIsEnumerable.call(n, e[o]) && (t[e[o]] = n[e[o]]);
  return t;
}, Xt = (
  /** @class */
  function(n) {
    pr(r, n);
    function r() {
      var t = n !== null && n.apply(this, arguments) || this;
      return t.mapFiles = function() {
        var e = t.props.files;
        return e.map(function(o) {
          return d.createElement(
            "span",
            { key: o.name, className: "k-file-info" },
            d.createElement("span", { className: "k-file-name", title: o.name }, o.name),
            T.fileHasValidationErrors(o) ? d.createElement("span", { className: "k-file-validation-message" }, t.getFileValidationMessage(o)) : d.createElement("span", { key: "".concat(o.name, "-size"), className: "k-file-size" }, T.getTotalFilesSizeMessage([o]))
          );
        });
      }, t.progress = function() {
        var e = t.props.files, o = 0;
        return e.forEach(function(a) {
          o += a.progress || 0;
        }), o / e.length;
      }, t;
    }
    return r.prototype.getFileValidationMessage = function(t) {
      var e = j(this), o = "";
      if (t.validationErrors && t.validationErrors.length > 0) {
        var a = "upload.".concat(t.validationErrors[0]);
        o = e.toLanguageString(a, _[a]);
      }
      return o;
    }, r.prototype.render = function() {
      var t = this.props, e = t.files, o = vr(t, ["files"]), a = T.getFileStatus(e), i = a[1], s = a[2], u = a[3], l = j(this), f = l.toLanguageString(ze, _[ze]), c = l.toLanguageString($e, _[$e]), p = l.toLanguageString(Z, _[Z]), h = l.toLanguageString(X, _[X]), m = this.progress();
      return d.createElement(
        "div",
        { className: C("k-file-multiple") },
        !u && !i && !s && d.createElement(Bt, { value: m || 0 }),
        d.createElement(
          "span",
          { className: "k-file-icon-wrapper" },
          d.createElement(re, { className: "k-file-icon", name: "copy", icon: Rn, size: "xxlarge" })
        ),
        d.createElement(
          "span",
          { className: "k-multiple-files-wrapper" },
          this.mapFiles(),
          s ? d.createElement("span", { className: "k-file-validation-message" }, "".concat(e.length, " ").concat(p)) : m !== 100 ? d.createElement("span", { className: "k-file-summary" }, "".concat(f, ": ").concat(e.length, " ").concat(c, ", ").concat(T.getTotalFilesSizeMessage(e))) : d.createElement("span", { className: "k-file-summary k-text-success" }, "".concat(e.length, " ").concat(h))
        ),
        d.createElement(rt, He({ uid: e[0].uid, status: e[0].status, progress: m }, o))
      );
    }, r;
  }(d.Component)
);
N(Xt);
var hr = globalThis && globalThis.__extends || function() {
  var n = function(r, t) {
    return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, o) {
      e.__proto__ = o;
    } || function(e, o) {
      for (var a in o)
        Object.prototype.hasOwnProperty.call(o, a) && (e[a] = o[a]);
    }, n(r, t);
  };
  return function(r, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    n(r, t);
    function e() {
      this.constructor = r;
    }
    r.prototype = t === null ? Object.create(t) : (e.prototype = t.prototype, new e());
  };
}(), Ve = globalThis && globalThis.__assign || function() {
  return Ve = Object.assign || function(n) {
    for (var r, t = 1, e = arguments.length; t < e; t++) {
      r = arguments[t];
      for (var o in r)
        Object.prototype.hasOwnProperty.call(r, o) && (n[o] = r[o]);
    }
    return n;
  }, Ve.apply(this, arguments);
}, mr = (
  /** @class */
  function(n) {
    hr(r, n);
    function r() {
      var t = n !== null && n.apply(this, arguments) || this;
      return t._element = null, t.onClick = function() {
        t.props.onClick.call(void 0, t.props.index);
      }, t;
    }
    return r.prototype.componentDidUpdate = function() {
      var t = this.props, e = t.navigationIndex, o = t.index, a = zt(document);
      e === o && this._element && a !== this._element && this._element.focus();
    }, r.prototype.render = function() {
      var t = this, e = this.props, o = e.files, a = e.async, i = e.disabled, s = e.navigationIndex, u = e.index, l = e.listItemUI, f = e.onCancel, c = e.onRemove, p = e.onRetry, h = o[0], m = h.status === y.Uploaded || h.status === y.Initial, x = C("k-file", T.filesHaveValidationErrors(o) ? "k-file-error k-file-invalid" : "", h.status === y.UploadFailed || h.status === y.RemoveFailed ? "k-file-error" : "", h.status === y.Uploading ? "k-file-progress" : "", m ? "k-file-success" : "", s === u ? "k-focus" : ""), w = {
        async: a,
        disabled: i,
        onCancel: f,
        onRemove: c,
        onRetry: p
      }, O = l || (o.length === 1 ? Jt : Xt);
      return d.createElement(
        "li",
        { ref: function(S) {
          return t._element = S;
        }, className: x, "data-uid": h.uid, tabIndex: -1, onClick: this.onClick },
        d.createElement(O, Ve({ files: o }, w))
      );
    }, r;
  }(d.Component)
), gr = globalThis && globalThis.__extends || function() {
  var n = function(r, t) {
    return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, o) {
      e.__proto__ = o;
    } || function(e, o) {
      for (var a in o)
        Object.prototype.hasOwnProperty.call(o, a) && (e[a] = o[a]);
    }, n(r, t);
  };
  return function(r, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    n(r, t);
    function e() {
      this.constructor = r;
    }
    r.prototype = t === null ? Object.create(t) : (e.prototype = t.prototype, new e());
  };
}(), Ke = globalThis && globalThis.__assign || function() {
  return Ke = Object.assign || function(n) {
    for (var r, t = 1, e = arguments.length; t < e; t++) {
      r = arguments[t];
      for (var o in r)
        Object.prototype.hasOwnProperty.call(r, o) && (n[o] = r[o]);
    }
    return n;
  }, Ke.apply(this, arguments);
}, yr = globalThis && globalThis.__rest || function(n, r) {
  var t = {};
  for (var e in n)
    Object.prototype.hasOwnProperty.call(n, e) && r.indexOf(e) < 0 && (t[e] = n[e]);
  if (n != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, e = Object.getOwnPropertySymbols(n); o < e.length; o++)
      r.indexOf(e[o]) < 0 && Object.prototype.propertyIsEnumerable.call(n, e[o]) && (t[e[o]] = n[e[o]]);
  return t;
}, br = (
  /** @class */
  function(n) {
    gr(r, n);
    function r() {
      return n !== null && n.apply(this, arguments) || this;
    }
    return r.prototype.mapListGroups = function() {
      var t = this.props, e = t.groupedFiles, o = t.navigationIndex, a = yr(t, ["groupedFiles", "navigationIndex"]);
      return Object.keys(e).map(function(i, s) {
        var u = e[i];
        return d.createElement(mr, Ke({ key: i, files: u, index: s, navigationIndex: o }, a));
      });
    }, r.prototype.render = function() {
      var t = C("k-upload-files", "k-reset");
      return d.createElement("ul", { className: t }, this.mapListGroups());
    }, r;
  }(d.Component)
), _r = globalThis && globalThis.__extends || function() {
  var n = function(r, t) {
    return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, o) {
      e.__proto__ = o;
    } || function(e, o) {
      for (var a in o)
        Object.prototype.hasOwnProperty.call(o, a) && (e[a] = o[a]);
    }, n(r, t);
  };
  return function(r, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    n(r, t);
    function e() {
      this.constructor = r;
    }
    r.prototype = t === null ? Object.create(t) : (e.prototype = t.prototype, new e());
  };
}(), Or = /(chrome)[ \/]([\w.]+)/i, Er = /(webkit)[ \/]([\w.]+)/i, Zt = (
  /** @class */
  function(n) {
    _r(r, n);
    function r() {
      var t = n !== null && n.apply(this, arguments) || this;
      return t._input = null, t.onMouseDown = function(e) {
        t.props.onMouseDown && t.props.onMouseDown(e);
      }, t.onAdd = function() {
        var e = navigator.userAgent, o = t._input;
        o && (t.props.onAdd && o.files && t.props.onAdd.call(void 0, o.files), !e.match(Or) && e.match(Er) || (o.type = "", o.type = "file"));
      }, t;
    }
    return Object.defineProperty(r.prototype, "actionElement", {
      get: function() {
        return this._input;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.render = function() {
      var t = this, e = this.props, o = e.multiple, a = e.async, i = e.disabled, s = e.accept, u = e.hasFiles, l = e.ariaLabelledBy, f = e.ariaDescribedBy, c = e.id, p = j(this), h = u ? $t : Ht, m = p.toLanguageString(h, _[h]), x = p.toLanguageString(J, _[J]);
      return d.createElement("input", { id: c, ref: function(w) {
        return t._input = w;
      }, className: "k-hidden", autoComplete: "off", name: a.saveField, accept: s, type: "file", multiple: o, disabled: i, onChange: this.onAdd, onMouseDown: this.onMouseDown, title: m, "aria-label": l !== void 0 ? void 0 : x, "aria-labelledby": l, "aria-describedby": f });
    }, r;
  }(d.Component)
);
N(Zt);
var wr = globalThis && globalThis.__extends || function() {
  var n = function(r, t) {
    return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, o) {
      e.__proto__ = o;
    } || function(e, o) {
      for (var a in o)
        Object.prototype.hasOwnProperty.call(o, a) && (e[a] = o[a]);
    }, n(r, t);
  };
  return function(r, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    n(r, t);
    function e() {
      this.constructor = r;
    }
    r.prototype = t === null ? Object.create(t) : (e.prototype = t.prototype, new e());
  };
}(), Ge = globalThis && globalThis.__assign || function() {
  return Ge = Object.assign || function(n) {
    for (var r, t = 1, e = arguments.length; t < e; t++) {
      r = arguments[t];
      for (var o in r)
        Object.prototype.hasOwnProperty.call(r, o) && (n[o] = r[o]);
    }
    return n;
  }, Ge.apply(this, arguments);
}, xr = globalThis && globalThis.__rest || function(n, r) {
  var t = {};
  for (var e in n)
    Object.prototype.hasOwnProperty.call(n, e) && r.indexOf(e) < 0 && (t[e] = n[e]);
  if (n != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, e = Object.getOwnPropertySymbols(n); o < e.length; o++)
      r.indexOf(e[o]) < 0 && Object.prototype.propertyIsEnumerable.call(n, e[o]) && (t[e[o]] = n[e[o]]);
  return t;
}, Cr = function(n) {
  return d.createElement("span", { "aria-hidden": !0 }, n.message);
}, Wt = (
  /** @class */
  function(n) {
    wr(r, n);
    function r() {
      var t = n !== null && n.apply(this, arguments) || this;
      return t._element = null, t._uploadInput = null, t.focus = function() {
        t._element && t._element.focus();
      }, t.onClick = function() {
        t.actionElement && t.actionElement.click(), t.props.onClick.call(void 0, t.props.addButtonIndex);
      }, t.onInputMouseDown = function(e) {
        t._element && (e.preventDefault(), t._element.focus());
      }, t;
    }
    return Object.defineProperty(r.prototype, "actionElement", {
      get: function() {
        if (this._uploadInput)
          return this._uploadInput.actionElement;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.componentDidUpdate = function(t) {
      var e = this.props, o = e.navigationIndex, a = e.addButtonIndex, i = e.notFocusedIndex;
      o !== t.navigationIndex && t.navigationIndex !== i && o === a && this._element && this._element.focus();
    }, r.prototype.render = function() {
      var t = this, e = this.props, o = e.navigationIndex, a = e.addButtonIndex, i = e.tabIndex, s = e.id, u = e.selectMessageUI, l = xr(e, ["navigationIndex", "addButtonIndex", "tabIndex", "id", "selectMessageUI"]), f = j(this), c = f.toLanguageString(J, _[J]), p = u || Cr;
      return d.createElement(
        "div",
        { className: "k-upload-button-wrap" },
        d.createElement(
          Re,
          { type: "button", id: s, className: C("k-upload-button", o === a ? "k-focus" : ""), themeColor: "base", tabIndex: i, onClick: this.onClick, "aria-label": c },
          d.createElement(p, { message: c })
        ),
        d.createElement(Zt, Ge({ id: s }, l, { onMouseDown: this.onInputMouseDown, ref: function(h) {
          return t._uploadInput = h;
        } }))
      );
    }, r;
  }(d.Component)
);
N(Wt);
var Sr = globalThis && globalThis.__extends || function() {
  var n = function(r, t) {
    return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, o) {
      e.__proto__ = o;
    } || function(e, o) {
      for (var a in o)
        Object.prototype.hasOwnProperty.call(o, a) && (e[a] = o[a]);
    }, n(r, t);
  };
  return function(r, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    n(r, t);
    function e() {
      this.constructor = r;
    }
    r.prototype = t === null ? Object.create(t) : (e.prototype = t.prototype, new e());
  };
}(), Yt = (
  /** @class */
  function(n) {
    Sr(r, n);
    function r() {
      var t = n !== null && n.apply(this, arguments) || this;
      return t._uploadElement = null, t._clearElement = null, t.onClearClick = function() {
        t.props.disabled || t.props.onClear && t.props.onClear.call(void 0);
      }, t.onUploadClick = function() {
        t.props.disabled || (t.props.onClick.call(void 0, t.props.uploadButtonIndex), t.props.onUpload && t.props.onUpload.call(void 0));
      }, t;
    }
    return r.prototype.componentDidUpdate = function(t) {
      var e = this.props, o = e.navigationIndex, a = e.clearButtonIndex, i = e.uploadButtonIndex;
      o !== t.navigationIndex && (o === a && this._clearElement && this._clearElement.focus(), o === i && this._uploadElement && this._uploadElement.focus());
    }, r.prototype.render = function() {
      var t = this, e = this.props, o = e.disabled, a = e.navigationIndex, i = e.clearButtonIndex, s = e.uploadButtonIndex, u = e.actionsLayout, l = j(this), f = C("k-actions", "k-hstack", {
        "k-justify-content-start": u === "start",
        "k-justify-content-center": u === "center",
        "k-justify-content-end": u === "end",
        "k-justify-content-stretch": u === "stretched"
      }), c = C("k-button k-button-md k-rounded-md k-button-solid k-button-solid-base", "k-clear-selected", o ? "k-disabled" : "", a === i ? "k-focus" : ""), p = C("k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary", "k-primary", "k-upload-selected", o ? "k-disabled" : "", a === s ? "k-focus" : "");
      return d.createElement(
        "div",
        { className: f },
        d.createElement("button", { ref: function(h) {
          return t._clearElement = h;
        }, type: "button", className: c, tabIndex: -1, onClick: this.onClearClick }, l.toLanguageString(De, _[De])),
        d.createElement("button", { ref: function(h) {
          return t._uploadElement = h;
        }, type: "button", className: p, tabIndex: -1, onClick: this.onUploadClick }, l.toLanguageString(qe, _[qe]))
      );
    }, r;
  }(d.Component)
);
N(Yt);
var Ir = globalThis && globalThis.__extends || function() {
  var n = function(r, t) {
    return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, o) {
      e.__proto__ = o;
    } || function(e, o) {
      for (var a in o)
        Object.prototype.hasOwnProperty.call(o, a) && (e[a] = o[a]);
    }, n(r, t);
  };
  return function(r, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    n(r, t);
    function e() {
      this.constructor = r;
    }
    r.prototype = t === null ? Object.create(t) : (e.prototype = t.prototype, new e());
  };
}(), Je = globalThis && globalThis.__assign || function() {
  return Je = Object.assign || function(n) {
    for (var r, t = 1, e = arguments.length; t < e; t++) {
      r = arguments[t];
      for (var o in r)
        Object.prototype.hasOwnProperty.call(r, o) && (n[o] = r[o]);
    }
    return n;
  }, Je.apply(this, arguments);
}, Qt = (
  /** @class */
  function(n) {
    Ir(r, n);
    function r() {
      return n !== null && n.apply(this, arguments) || this;
    }
    return r.prototype.render = function() {
      var t = this.props, e = t.isUploading, o = t.isUploaded, a = t.isUploadFailed, i = C("k-upload-status"), s = !e && !a && o ? "check" : !e && a ? "exclamation-circle" : e ? "upload" : "", u = !e && !a && o ? { icon: Tn } : !e && a ? { icon: jn } : e ? { icon: An } : {}, l = "", f = j(this);
      return e ? l = f.toLanguageString(Ne, _[Ne]) : (o || a) && (l = f.toLanguageString(Me, _[Me])), d.createElement(
        "div",
        { className: i },
        d.createElement(re, Je({ name: s }, u)),
        l
      );
    }, r;
  }(d.Component)
);
N(Qt);
var Ur = globalThis && globalThis.__extends || function() {
  var n = function(r, t) {
    return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, o) {
      e.__proto__ = o;
    } || function(e, o) {
      for (var a in o)
        Object.prototype.hasOwnProperty.call(o, a) && (e[a] = o[a]);
    }, n(r, t);
  };
  return function(r, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    n(r, t);
    function e() {
      this.constructor = r;
    }
    r.prototype = t === null ? Object.create(t) : (e.prototype = t.prototype, new e());
  };
}(), fe = 100, en = (
  /** @class */
  function(n) {
    Ur(r, n);
    function r() {
      var t = n !== null && n.apply(this, arguments) || this;
      return t._lastDocumentDragOver = null, t._lastElementDragOver = null, t._documentActive = !1, t._elementActive = !1, t.onDocumentDragEnter = function() {
        if (!t.documentActive) {
          t.documentActive = !0;
          var e = function() {
            t.isDragOver(t._lastDocumentDragOver) && (t.documentActive = !1, clearInterval(t._documentInterval), t._documentInterval = null, t._lastDocumentDragOver = null);
          };
          t._documentInterval = setInterval(e, fe);
        }
      }, t.onDocumentDragOver = function() {
        t._lastDocumentDragOver = /* @__PURE__ */ new Date();
      }, t.onElementDragEnter = function() {
        if (!t.elementActive) {
          t.elementActive = !0;
          var e = function() {
            t.isDragOver(t._lastElementDragOver) && (t.elementActive = !1, clearInterval(t._elementInterval), t._elementInterval = null, t._lastElementDragOver = null);
          };
          t._elementInterval = setInterval(e, fe);
        }
      }, t.onElementDragOver = function(e) {
        e.preventDefault(), t._lastElementDragOver = /* @__PURE__ */ new Date();
      }, t.onDrop = function(e) {
        e.preventDefault();
        var o = e.dataTransfer.files;
        o.length > 0 && !t.props.disabled && t.props.onAdd && (t.props.multiple || o.length <= 1) && t.props.onAdd.call(void 0, o);
      }, t.isDragOver = function(e) {
        return (/* @__PURE__ */ new Date()).getTime() - (e || /* @__PURE__ */ new Date()).getTime() > fe;
      }, t;
    }
    return Object.defineProperty(r.prototype, "documentActive", {
      get: function() {
        return this._documentActive;
      },
      set: function(t) {
        var e = this.documentActive;
        this._documentActive = t, t !== e && this.forceUpdate();
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "elementActive", {
      get: function() {
        return this._elementActive;
      },
      set: function(t) {
        var e = this._elementActive;
        this._elementActive = t, t !== e && this.setState({});
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.componentDidMount = function() {
      document.addEventListener("dragenter", this.onDocumentDragEnter), document.addEventListener("dragover", this.onDocumentDragOver);
    }, r.prototype.componentWillUnmount = function() {
      document.removeEventListener("dragenter", this.onDocumentDragEnter), document.removeEventListener("dragover", this.onDocumentDragOver);
    }, r.prototype.render = function() {
      var t = this.props, e = t.addButtonComponent, o = t.fileGroup, a = j(this), i = a.toLanguageString(Pe, _[Pe]), s = C("k-dropzone k-upload-dropzone", this.documentActive ? "k-dropzone-active" : "", this.elementActive ? "k-dropzone-hovered" : ""), u = T.getFileStatus(o), l = u[0], f = u[1], c = u[2], p = u[3], h = C("k-dropzone-hint", {
        // Unsure about that, since it hides the "Drop Files Message" when we remove all uploaded components.
        // 'k-hidden': this.isDragged && !this.elementActive
      });
      return d.createElement(
        "div",
        { className: s, onDrop: this.onDrop, onDragEnter: this.onElementDragEnter, onDragOver: this.onElementDragOver },
        e,
        l || f || c || p ? d.createElement(Qt, { isUploading: l, isUploaded: f, isUploadFailed: c }) : d.createElement("div", { className: h }, i)
      );
    }, r;
  }(d.Component)
);
N(en);
var Fr = globalThis && globalThis.__extends || function() {
  var n = function(r, t) {
    return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, o) {
      e.__proto__ = o;
    } || function(e, o) {
      for (var a in o)
        Object.prototype.hasOwnProperty.call(o, a) && (e[a] = o[a]);
    }, n(r, t);
  };
  return function(r, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    n(r, t);
    function e() {
      this.constructor = r;
    }
    r.prototype = t === null ? Object.create(t) : (e.prototype = t.prototype, new e());
  };
}(), kr = -1, Rr = (
  /** @class */
  function(n) {
    Fr(r, n);
    function r() {
      var t = n !== null && n.apply(this, arguments) || this;
      return t._container = null, t._uploadAddButton = null, t.focus = function() {
        if (t._uploadAddButton)
          return t._uploadAddButton.focus();
      }, t.onAdd = function(e) {
        t.props.onAdd && t.props.onAdd.call(void 0, e);
      }, t.onRetry = function(e) {
        t.props.onRetry && t.props.onRetry.call(void 0, e);
      }, t.onCancel = function(e) {
        t.props.onCancel && t.props.onCancel.call(void 0, e);
      }, t.onClear = function() {
        t.props.onClear && t.props.onClear.call(void 0);
      }, t.onUpload = function() {
        t.props.onUpload && t.props.onUpload.call(void 0);
      }, t.onRemove = function(e) {
        t.props.onRemove && t.props.onRemove.call(void 0, e);
      }, t.onKeyDown = function(e) {
        t.props.onKeyDown && t.props.onKeyDown.call(void 0, e, t.isRtl);
      }, t.onFocus = function(e) {
        t.props.onFocus && t.props.onFocus.call(void 0, e);
      }, t.onBlur = function(e) {
        t.props.onBlur && t.props.onBlur.call(void 0, e);
      }, t.onClick = function(e) {
        t.props.onClick && t.props.onClick.call(void 0, e);
      }, t;
    }
    return Object.defineProperty(r.prototype, "async", {
      get: function() {
        var t = this.props, e = t.autoUpload, o = t.batch, a = t.withCredentials, i = t.saveField, s = t.saveHeaders, u = t.saveMethod, l = t.saveUrl, f = t.responseType, c = t.removeField, p = t.removeHeaders, h = t.removeMethod, m = t.removeUrl;
        return {
          autoUpload: e,
          batch: o,
          withCredentials: a,
          saveField: i,
          saveHeaders: s,
          saveMethod: u,
          saveUrl: l,
          responseType: f,
          removeField: c,
          removeHeaders: p,
          removeMethod: h,
          removeUrl: m
        };
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "groupsCount", {
      get: function() {
        return Object.keys(this.props.groupedFiles).length;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "lastGroupIndex", {
      get: function() {
        return this.groupsCount - 1;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "addButtonIndex", {
      get: function() {
        return kr;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "clearButtonIndex", {
      get: function() {
        return this.lastGroupIndex + 1;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "uploadButtonIndex", {
      get: function() {
        return this.lastGroupIndex + 2;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "isRtl", {
      get: function() {
        return this._container && getComputedStyle(this._container).direction === "rtl" || !1;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "actionElement", {
      /**
       * @hidden
       */
      get: function() {
        if (this._uploadAddButton)
          return this._uploadAddButton.actionElement;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.render = function() {
      var t = this, e = this.props, o = e.multiple, a = e.disabled, i = e.tabIndex, s = e.accept, u = e.showFileList, l = e.groupedFiles, f = e.navigationIndex, c = e.showActionButtons, p = e.actionsLayout, h = e.notFocusedIndex, m = e.listItemUI, x = e.id, w = e.ariaLabelledBy, O = e.ariaDescribedBy, S = e.selectMessageUI, k = C("k-upload", this.props.className, a ? "k-disabled" : ""), g = d.createElement(Wt, { id: x, ariaLabelledBy: w, ariaDescribedBy: O, ref: function(B) {
        return t._uploadAddButton = B;
      }, accept: s, async: this.async, addButtonIndex: this.addButtonIndex, navigationIndex: f, notFocusedIndex: h, tabIndex: i, multiple: o, disabled: a, hasFiles: l ? Object.keys(l).length > 0 : !1, selectMessageUI: S, onAdd: this.onAdd, onClick: this.onClick });
      return d.createElement(
        "div",
        { ref: function(B) {
          return t._container = B;
        }, className: k, onKeyDown: this.onKeyDown, onFocus: this.onFocus, onBlur: this.onBlur },
        d.createElement(en, { addButtonComponent: g, fileGroup: l, disabled: a, multiple: o, onAdd: this.onAdd }),
        u ? d.createElement(br, { groupedFiles: l, disabled: a, async: this.async, navigationIndex: f, listItemUI: m, onCancel: this.onCancel, onRemove: this.onRemove, onRetry: this.onRetry, onClick: this.onClick }) : void 0,
        c ? d.createElement(Yt, { disabled: a, navigationIndex: f, clearButtonIndex: this.clearButtonIndex, uploadButtonIndex: this.uploadButtonIndex, actionsLayout: p, onUpload: this.onUpload, onClear: this.onClear, onClick: this.onClick }) : void 0
      );
    }, r.defaultProps = {
      disabled: !1,
      groupedFiles: {},
      multiple: !0,
      actionsLayout: "end"
    }, r;
  }(d.Component)
), Tr = globalThis && globalThis.__extends || function() {
  var n = function(r, t) {
    return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, o) {
      e.__proto__ = o;
    } || function(e, o) {
      for (var a in o)
        Object.prototype.hasOwnProperty.call(o, a) && (e[a] = o[a]);
    }, n(r, t);
  };
  return function(r, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    n(r, t);
    function e() {
      this.constructor = r;
    }
    r.prototype = t === null ? Object.create(t) : (e.prototype = t.prototype, new e());
  };
}(), Xe = globalThis && globalThis.__assign || function() {
  return Xe = Object.assign || function(n) {
    for (var r, t = 1, e = arguments.length; t < e; t++) {
      r = arguments[t];
      for (var o in r)
        Object.prototype.hasOwnProperty.call(r, o) && (n[o] = r[o]);
    }
    return n;
  }, Xe.apply(this, arguments);
}, jr = globalThis && globalThis.__rest || function(n, r) {
  var t = {};
  for (var e in n)
    Object.prototype.hasOwnProperty.call(n, e) && r.indexOf(e) < 0 && (t[e] = n[e]);
  if (n != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, e = Object.getOwnPropertySymbols(n); o < e.length; o++)
      r.indexOf(e[o]) < 0 && Object.prototype.propertyIsEnumerable.call(n, e[o]) && (t[e[o]] = n[e[o]]);
  return t;
}, q = -2, P = -1, Ar = (
  /** @class */
  function(n) {
    Tr(r, n);
    function r(t) {
      var e = n.call(this, t) || this;
      return e._uploadUI = null, e.focus = function() {
        e._uploadUI && e._uploadUI.focus();
      }, e.onKeyDown = function(o, a) {
        var i = e.navIndex, s = Object.keys(e.props.groupedFiles), u = s.length - 1, l = e.props.autoUpload || s.length === 0 ? u : u + 1, f = u + 1, c = f + 1, p = i === q ? P : i, h = i;
        switch (o.keyCode) {
          case D.up:
            i > -1 && (h = p - 1);
            break;
          case D.down:
            i < l && (h = p + 1);
            break;
          case D.left:
            a ? i === f && (h = p + 1) : i === c && (h = p - 1);
            break;
          case D.right:
            a ? i === c && (h = p - 1) : i === f && (h = p + 1);
            break;
          case D.enter:
            if (i === P || i === q) {
              var m = zt(document);
              e.actionElement && Mn && (m == null ? void 0 : m.className.indexOf("k-upload-button")) === -1 && e.actionElement.click();
            }
            i >= 0 && i <= u && e.onRetry(s[i]);
            break;
          case D.space:
            (i === P || i === q) && e.actionElement && e.actionElement.click(), o.preventDefault();
            break;
          case D.tab:
            h = q;
            break;
          case D.delete:
            i >= 0 && i <= u && (h = p - 1, e.onRemove(s[i]));
            break;
          case D.esc:
            i >= 0 && i <= u && (h = p - 1, e.onCancel(s[i]));
            break;
        }
        e.navIndex = h;
      }, e.onCancel = function(o) {
        e.props.onCancel && e.props.onCancel.call(void 0, o);
      }, e.onClear = function() {
        e.navIndex = P, e.props.onClear && e.props.onClear.call(void 0);
      }, e.onUpload = function() {
        e.navIndex = P, e.props.onUpload && e.props.onUpload.call(void 0);
      }, e.onRetry = function(o) {
        e.props.onRetry && e.props.onRetry.call(void 0, o);
      }, e.onRemove = function(o) {
        e.navIndex = e.navIndex > P ? e.navIndex - 1 : P, e.props.onRemove && e.props.onRemove.call(void 0, o);
      }, e.onAdd = function(o) {
        e.navIndex = P, e.props.onAdd && e.props.onAdd.call(void 0, o);
      }, e.onClick = function(o) {
        e.navIndex = o;
      }, e.onFocus = function() {
        e._blurTimeout && (clearTimeout(e._blurTimeout), e._blurTimeout = void 0);
      }, e.onBlurTimeout = function() {
        e.navIndex = q, e._blurTimeout = void 0;
      }, e.onBlur = function() {
        clearTimeout(e._blurTimeout), e._blurTimeout = window.setTimeout(e.onBlurTimeout);
      }, e._navIndex = q, e;
    }
    return Object.defineProperty(r.prototype, "navIndex", {
      get: function() {
        return this._navIndex;
      },
      set: function(t) {
        var e = this.navIndex;
        this._navIndex = t, t !== e && this.forceUpdate();
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "actionElement", {
      get: function() {
        if (this._uploadUI)
          return this._uploadUI.actionElement;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.componentDidUpdate = function(t) {
      var e = Object.keys(t.groupedFiles).length, o = Object.keys(this.props.groupedFiles).length;
      e > o && this.navIndex > P && (this.navIndex = this.navIndex - (e - o));
    }, r.prototype.render = function() {
      var t = this, e = this.props;
      e.onClear, e.onRemove, e.onRetry, e.onCancel, e.onUpload, e.onAdd;
      var o = jr(e, ["onClear", "onRemove", "onRetry", "onCancel", "onUpload", "onAdd"]);
      return d.createElement(Rr, Xe({ ref: function(a) {
        return t._uploadUI = a;
      }, className: this.props.className, onKeyDown: this.onKeyDown, navigationIndex: this.navIndex, notFocusedIndex: q, onAdd: this.onAdd, onClear: this.onClear, onUpload: this.onUpload, onRemove: this.onRemove, onRetry: this.onRetry, onCancel: this.onCancel, onClick: this.onClick, onFocus: this.onFocus, onBlur: this.onBlur }, o));
    }, r;
  }(d.Component)
), ot = { exports: {} }, tn = function(r, t) {
  return function() {
    for (var o = new Array(arguments.length), a = 0; a < o.length; a++)
      o[a] = arguments[a];
    return r.apply(t, o);
  };
}, Dr = tn, $ = Object.prototype.toString;
function at(n) {
  return $.call(n) === "[object Array]";
}
function Ze(n) {
  return typeof n > "u";
}
function Pr(n) {
  return n !== null && !Ze(n) && n.constructor !== null && !Ze(n.constructor) && typeof n.constructor.isBuffer == "function" && n.constructor.isBuffer(n);
}
function Mr(n) {
  return $.call(n) === "[object ArrayBuffer]";
}
function Nr(n) {
  return typeof FormData < "u" && n instanceof FormData;
}
function Br(n) {
  var r;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? r = ArrayBuffer.isView(n) : r = n && n.buffer && n.buffer instanceof ArrayBuffer, r;
}
function Lr(n) {
  return typeof n == "string";
}
function qr(n) {
  return typeof n == "number";
}
function nn(n) {
  return n !== null && typeof n == "object";
}
function Q(n) {
  if ($.call(n) !== "[object Object]")
    return !1;
  var r = Object.getPrototypeOf(n);
  return r === null || r === Object.prototype;
}
function zr(n) {
  return $.call(n) === "[object Date]";
}
function $r(n) {
  return $.call(n) === "[object File]";
}
function Hr(n) {
  return $.call(n) === "[object Blob]";
}
function rn(n) {
  return $.call(n) === "[object Function]";
}
function Vr(n) {
  return nn(n) && rn(n.pipe);
}
function Kr(n) {
  return typeof URLSearchParams < "u" && n instanceof URLSearchParams;
}
function Gr(n) {
  return n.trim ? n.trim() : n.replace(/^\s+|\s+$/g, "");
}
function Jr() {
  return typeof navigator < "u" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS") ? !1 : typeof window < "u" && typeof document < "u";
}
function it(n, r) {
  if (!(n === null || typeof n > "u"))
    if (typeof n != "object" && (n = [n]), at(n))
      for (var t = 0, e = n.length; t < e; t++)
        r.call(null, n[t], t, n);
    else
      for (var o in n)
        Object.prototype.hasOwnProperty.call(n, o) && r.call(null, n[o], o, n);
}
function We() {
  var n = {};
  function r(o, a) {
    Q(n[a]) && Q(o) ? n[a] = We(n[a], o) : Q(o) ? n[a] = We({}, o) : at(o) ? n[a] = o.slice() : n[a] = o;
  }
  for (var t = 0, e = arguments.length; t < e; t++)
    it(arguments[t], r);
  return n;
}
function Xr(n, r, t) {
  return it(r, function(o, a) {
    t && typeof o == "function" ? n[a] = Dr(o, t) : n[a] = o;
  }), n;
}
function Zr(n) {
  return n.charCodeAt(0) === 65279 && (n = n.slice(1)), n;
}
var U = {
  isArray: at,
  isArrayBuffer: Mr,
  isBuffer: Pr,
  isFormData: Nr,
  isArrayBufferView: Br,
  isString: Lr,
  isNumber: qr,
  isObject: nn,
  isPlainObject: Q,
  isUndefined: Ze,
  isDate: zr,
  isFile: $r,
  isBlob: Hr,
  isFunction: rn,
  isStream: Vr,
  isURLSearchParams: Kr,
  isStandardBrowserEnv: Jr,
  forEach: it,
  merge: We,
  extend: Xr,
  trim: Gr,
  stripBOM: Zr
}, V = U;
function pt(n) {
  return encodeURIComponent(n).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
var on = function(r, t, e) {
  if (!t)
    return r;
  var o;
  if (e)
    o = e(t);
  else if (V.isURLSearchParams(t))
    o = t.toString();
  else {
    var a = [];
    V.forEach(t, function(u, l) {
      u === null || typeof u > "u" || (V.isArray(u) ? l = l + "[]" : u = [u], V.forEach(u, function(c) {
        V.isDate(c) ? c = c.toISOString() : V.isObject(c) && (c = JSON.stringify(c)), a.push(pt(l) + "=" + pt(c));
      }));
    }), o = a.join("&");
  }
  if (o) {
    var i = r.indexOf("#");
    i !== -1 && (r = r.slice(0, i)), r += (r.indexOf("?") === -1 ? "?" : "&") + o;
  }
  return r;
}, Wr = U;
function oe() {
  this.handlers = [];
}
oe.prototype.use = function(r, t, e) {
  return this.handlers.push({
    fulfilled: r,
    rejected: t,
    synchronous: e ? e.synchronous : !1,
    runWhen: e ? e.runWhen : null
  }), this.handlers.length - 1;
};
oe.prototype.eject = function(r) {
  this.handlers[r] && (this.handlers[r] = null);
};
oe.prototype.forEach = function(r) {
  Wr.forEach(this.handlers, function(e) {
    e !== null && r(e);
  });
};
var Yr = oe, Qr = U, eo = function(r, t) {
  Qr.forEach(r, function(o, a) {
    a !== t && a.toUpperCase() === t.toUpperCase() && (r[t] = o, delete r[a]);
  });
}, an = function(r, t, e, o, a) {
  return r.config = t, e && (r.code = e), r.request = o, r.response = a, r.isAxiosError = !0, r.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }, r;
}, de, vt;
function sn() {
  if (vt)
    return de;
  vt = 1;
  var n = an;
  return de = function(t, e, o, a, i) {
    var s = new Error(t);
    return n(s, e, o, a, i);
  }, de;
}
var pe, ht;
function to() {
  if (ht)
    return pe;
  ht = 1;
  var n = sn();
  return pe = function(t, e, o) {
    var a = o.config.validateStatus;
    !o.status || !a || a(o.status) ? t(o) : e(n(
      "Request failed with status code " + o.status,
      o.config,
      null,
      o.request,
      o
    ));
  }, pe;
}
var ve, mt;
function no() {
  if (mt)
    return ve;
  mt = 1;
  var n = U;
  return ve = n.isStandardBrowserEnv() ? (
    // Standard browser envs support document.cookie
    function() {
      return {
        write: function(e, o, a, i, s, u) {
          var l = [];
          l.push(e + "=" + encodeURIComponent(o)), n.isNumber(a) && l.push("expires=" + new Date(a).toGMTString()), n.isString(i) && l.push("path=" + i), n.isString(s) && l.push("domain=" + s), u === !0 && l.push("secure"), document.cookie = l.join("; ");
        },
        read: function(e) {
          var o = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
          return o ? decodeURIComponent(o[3]) : null;
        },
        remove: function(e) {
          this.write(e, "", Date.now() - 864e5);
        }
      };
    }()
  ) : (
    // Non standard browser env (web workers, react-native) lack needed support.
    function() {
      return {
        write: function() {
        },
        read: function() {
          return null;
        },
        remove: function() {
        }
      };
    }()
  ), ve;
}
var he, gt;
function ro() {
  return gt || (gt = 1, he = function(r) {
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(r);
  }), he;
}
var me, yt;
function oo() {
  return yt || (yt = 1, me = function(r, t) {
    return t ? r.replace(/\/+$/, "") + "/" + t.replace(/^\/+/, "") : r;
  }), me;
}
var ge, bt;
function ao() {
  if (bt)
    return ge;
  bt = 1;
  var n = ro(), r = oo();
  return ge = function(e, o) {
    return e && !n(o) ? r(e, o) : o;
  }, ge;
}
var ye, _t;
function io() {
  if (_t)
    return ye;
  _t = 1;
  var n = U, r = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
  ];
  return ye = function(e) {
    var o = {}, a, i, s;
    return e && n.forEach(e.split(`
`), function(l) {
      if (s = l.indexOf(":"), a = n.trim(l.substr(0, s)).toLowerCase(), i = n.trim(l.substr(s + 1)), a) {
        if (o[a] && r.indexOf(a) >= 0)
          return;
        a === "set-cookie" ? o[a] = (o[a] ? o[a] : []).concat([i]) : o[a] = o[a] ? o[a] + ", " + i : i;
      }
    }), o;
  }, ye;
}
var be, Ot;
function so() {
  if (Ot)
    return be;
  Ot = 1;
  var n = U;
  return be = n.isStandardBrowserEnv() ? (
    // Standard browser envs have full support of the APIs needed to test
    // whether the request URL is of the same origin as current location.
    function() {
      var t = /(msie|trident)/i.test(navigator.userAgent), e = document.createElement("a"), o;
      function a(i) {
        var s = i;
        return t && (e.setAttribute("href", s), s = e.href), e.setAttribute("href", s), {
          href: e.href,
          protocol: e.protocol ? e.protocol.replace(/:$/, "") : "",
          host: e.host,
          search: e.search ? e.search.replace(/^\?/, "") : "",
          hash: e.hash ? e.hash.replace(/^#/, "") : "",
          hostname: e.hostname,
          port: e.port,
          pathname: e.pathname.charAt(0) === "/" ? e.pathname : "/" + e.pathname
        };
      }
      return o = a(window.location.href), function(s) {
        var u = n.isString(s) ? a(s) : s;
        return u.protocol === o.protocol && u.host === o.host;
      };
    }()
  ) : (
    // Non standard browser envs (web workers, react-native) lack needed support.
    function() {
      return function() {
        return !0;
      };
    }()
  ), be;
}
var _e, Et;
function ae() {
  if (Et)
    return _e;
  Et = 1;
  function n(r) {
    this.message = r;
  }
  return n.prototype.toString = function() {
    return "Cancel" + (this.message ? ": " + this.message : "");
  }, n.prototype.__CANCEL__ = !0, _e = n, _e;
}
var Oe, wt;
function xt() {
  if (wt)
    return Oe;
  wt = 1;
  var n = U, r = to(), t = no(), e = on, o = ao(), a = io(), i = so(), s = sn(), u = ie(), l = ae();
  return Oe = function(c) {
    return new Promise(function(h, m) {
      var x = c.data, w = c.headers, O = c.responseType, S;
      function k() {
        c.cancelToken && c.cancelToken.unsubscribe(S), c.signal && c.signal.removeEventListener("abort", S);
      }
      n.isFormData(x) && delete w["Content-Type"];
      var g = new XMLHttpRequest();
      if (c.auth) {
        var B = c.auth.username || "", ue = c.auth.password ? unescape(encodeURIComponent(c.auth.password)) : "";
        w.Authorization = "Basic " + btoa(B + ":" + ue);
      }
      var M = o(c.baseURL, c.url);
      g.open(c.method.toUpperCase(), e(M, c.params, c.paramsSerializer), !0), g.timeout = c.timeout;
      function ut() {
        if (g) {
          var F = "getAllResponseHeaders" in g ? a(g.getAllResponseHeaders()) : null, H = !O || O === "text" || O === "json" ? g.responseText : g.response, L = {
            data: H,
            status: g.status,
            statusText: g.statusText,
            headers: F,
            config: c,
            request: g
          };
          r(function(ce) {
            h(ce), k();
          }, function(ce) {
            m(ce), k();
          }, L), g = null;
        }
      }
      if ("onloadend" in g ? g.onloadend = ut : g.onreadystatechange = function() {
        !g || g.readyState !== 4 || g.status === 0 && !(g.responseURL && g.responseURL.indexOf("file:") === 0) || setTimeout(ut);
      }, g.onabort = function() {
        g && (m(s("Request aborted", c, "ECONNABORTED", g)), g = null);
      }, g.onerror = function() {
        m(s("Network Error", c, null, g)), g = null;
      }, g.ontimeout = function() {
        var H = "timeout of " + c.timeout + "ms exceeded", L = c.transitional || u.transitional;
        c.timeoutErrorMessage && (H = c.timeoutErrorMessage), m(s(
          H,
          c,
          L.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED",
          g
        )), g = null;
      }, n.isStandardBrowserEnv()) {
        var ct = (c.withCredentials || i(M)) && c.xsrfCookieName ? t.read(c.xsrfCookieName) : void 0;
        ct && (w[c.xsrfHeaderName] = ct);
      }
      "setRequestHeader" in g && n.forEach(w, function(H, L) {
        typeof x > "u" && L.toLowerCase() === "content-type" ? delete w[L] : g.setRequestHeader(L, H);
      }), n.isUndefined(c.withCredentials) || (g.withCredentials = !!c.withCredentials), O && O !== "json" && (g.responseType = c.responseType), typeof c.onDownloadProgress == "function" && g.addEventListener("progress", c.onDownloadProgress), typeof c.onUploadProgress == "function" && g.upload && g.upload.addEventListener("progress", c.onUploadProgress), (c.cancelToken || c.signal) && (S = function(F) {
        g && (m(!F || F && F.type ? new l("canceled") : F), g.abort(), g = null);
      }, c.cancelToken && c.cancelToken.subscribe(S), c.signal && (c.signal.aborted ? S() : c.signal.addEventListener("abort", S))), x || (x = null), g.send(x);
    });
  }, Oe;
}
var Ee, Ct;
function ie() {
  if (Ct)
    return Ee;
  Ct = 1;
  var n = U, r = eo, t = an, e = {
    "Content-Type": "application/x-www-form-urlencoded"
  };
  function o(u, l) {
    !n.isUndefined(u) && n.isUndefined(u["Content-Type"]) && (u["Content-Type"] = l);
  }
  function a() {
    var u;
    return (typeof XMLHttpRequest < "u" || typeof process < "u" && Object.prototype.toString.call(process) === "[object process]") && (u = xt()), u;
  }
  function i(u, l, f) {
    if (n.isString(u))
      try {
        return (l || JSON.parse)(u), n.trim(u);
      } catch (c) {
        if (c.name !== "SyntaxError")
          throw c;
      }
    return (f || JSON.stringify)(u);
  }
  var s = {
    transitional: {
      silentJSONParsing: !0,
      forcedJSONParsing: !0,
      clarifyTimeoutError: !1
    },
    adapter: a(),
    transformRequest: [function(l, f) {
      return r(f, "Accept"), r(f, "Content-Type"), n.isFormData(l) || n.isArrayBuffer(l) || n.isBuffer(l) || n.isStream(l) || n.isFile(l) || n.isBlob(l) ? l : n.isArrayBufferView(l) ? l.buffer : n.isURLSearchParams(l) ? (o(f, "application/x-www-form-urlencoded;charset=utf-8"), l.toString()) : n.isObject(l) || f && f["Content-Type"] === "application/json" ? (o(f, "application/json"), i(l)) : l;
    }],
    transformResponse: [function(l) {
      var f = this.transitional || s.transitional, c = f && f.silentJSONParsing, p = f && f.forcedJSONParsing, h = !c && this.responseType === "json";
      if (h || p && n.isString(l) && l.length)
        try {
          return JSON.parse(l);
        } catch (m) {
          if (h)
            throw m.name === "SyntaxError" ? t(m, this, "E_JSON_PARSE") : m;
        }
      return l;
    }],
    /**
     * A timeout in milliseconds to abort a request. If set to 0 (default) a
     * timeout is not created.
     */
    timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    validateStatus: function(l) {
      return l >= 200 && l < 300;
    },
    headers: {
      common: {
        Accept: "application/json, text/plain, */*"
      }
    }
  };
  return n.forEach(["delete", "get", "head"], function(l) {
    s.headers[l] = {};
  }), n.forEach(["post", "put", "patch"], function(l) {
    s.headers[l] = n.merge(e);
  }), Ee = s, Ee;
}
var lo = U, uo = ie(), co = function(r, t, e) {
  var o = this || uo;
  return lo.forEach(e, function(i) {
    r = i.call(o, r, t);
  }), r;
}, we, St;
function ln() {
  return St || (St = 1, we = function(r) {
    return !!(r && r.__CANCEL__);
  }), we;
}
var It = U, xe = co, fo = ln(), po = ie(), vo = ae();
function Ce(n) {
  if (n.cancelToken && n.cancelToken.throwIfRequested(), n.signal && n.signal.aborted)
    throw new vo("canceled");
}
var ho = function(r) {
  Ce(r), r.headers = r.headers || {}, r.data = xe.call(
    r,
    r.data,
    r.headers,
    r.transformRequest
  ), r.headers = It.merge(
    r.headers.common || {},
    r.headers[r.method] || {},
    r.headers
  ), It.forEach(
    ["delete", "get", "head", "post", "put", "patch", "common"],
    function(o) {
      delete r.headers[o];
    }
  );
  var t = r.adapter || po.adapter;
  return t(r).then(function(o) {
    return Ce(r), o.data = xe.call(
      r,
      o.data,
      o.headers,
      r.transformResponse
    ), o;
  }, function(o) {
    return fo(o) || (Ce(r), o && o.response && (o.response.data = xe.call(
      r,
      o.response.data,
      o.response.headers,
      r.transformResponse
    ))), Promise.reject(o);
  });
}, I = U, un = function(r, t) {
  t = t || {};
  var e = {};
  function o(f, c) {
    return I.isPlainObject(f) && I.isPlainObject(c) ? I.merge(f, c) : I.isPlainObject(c) ? I.merge({}, c) : I.isArray(c) ? c.slice() : c;
  }
  function a(f) {
    if (I.isUndefined(t[f])) {
      if (!I.isUndefined(r[f]))
        return o(void 0, r[f]);
    } else
      return o(r[f], t[f]);
  }
  function i(f) {
    if (!I.isUndefined(t[f]))
      return o(void 0, t[f]);
  }
  function s(f) {
    if (I.isUndefined(t[f])) {
      if (!I.isUndefined(r[f]))
        return o(void 0, r[f]);
    } else
      return o(void 0, t[f]);
  }
  function u(f) {
    if (f in t)
      return o(r[f], t[f]);
    if (f in r)
      return o(void 0, r[f]);
  }
  var l = {
    url: i,
    method: i,
    data: i,
    baseURL: s,
    transformRequest: s,
    transformResponse: s,
    paramsSerializer: s,
    timeout: s,
    timeoutMessage: s,
    withCredentials: s,
    adapter: s,
    responseType: s,
    xsrfCookieName: s,
    xsrfHeaderName: s,
    onUploadProgress: s,
    onDownloadProgress: s,
    decompress: s,
    maxContentLength: s,
    maxBodyLength: s,
    transport: s,
    httpAgent: s,
    httpsAgent: s,
    cancelToken: s,
    socketPath: s,
    responseEncoding: s,
    validateStatus: u
  };
  return I.forEach(Object.keys(r).concat(Object.keys(t)), function(c) {
    var p = l[c] || a, h = p(c);
    I.isUndefined(h) && p !== u || (e[c] = h);
  }), e;
}, Se, Ut;
function cn() {
  return Ut || (Ut = 1, Se = {
    version: "0.22.0"
  }), Se;
}
var mo = cn().version, st = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach(function(n, r) {
  st[n] = function(e) {
    return typeof e === n || "a" + (r < 1 ? "n " : " ") + n;
  };
});
var Ft = {};
st.transitional = function(r, t, e) {
  function o(a, i) {
    return "[Axios v" + mo + "] Transitional option '" + a + "'" + i + (e ? ". " + e : "");
  }
  return function(a, i, s) {
    if (r === !1)
      throw new Error(o(i, " has been removed" + (t ? " in " + t : "")));
    return t && !Ft[i] && (Ft[i] = !0, console.warn(
      o(
        i,
        " has been deprecated since v" + t + " and will be removed in the near future"
      )
    )), r ? r(a, i, s) : !0;
  };
};
function go(n, r, t) {
  if (typeof n != "object")
    throw new TypeError("options must be an object");
  for (var e = Object.keys(n), o = e.length; o-- > 0; ) {
    var a = e[o], i = r[a];
    if (i) {
      var s = n[a], u = s === void 0 || i(s, a, n);
      if (u !== !0)
        throw new TypeError("option " + a + " must be " + u);
      continue;
    }
    if (t !== !0)
      throw Error("Unknown option " + a);
  }
}
var yo = {
  assertOptions: go,
  validators: st
}, fn = U, bo = on, kt = Yr, Rt = ho, se = un, dn = yo, K = dn.validators;
function W(n) {
  this.defaults = n, this.interceptors = {
    request: new kt(),
    response: new kt()
  };
}
W.prototype.request = function(r) {
  typeof r == "string" ? (r = arguments[1] || {}, r.url = arguments[0]) : r = r || {}, r = se(this.defaults, r), r.method ? r.method = r.method.toLowerCase() : this.defaults.method ? r.method = this.defaults.method.toLowerCase() : r.method = "get";
  var t = r.transitional;
  t !== void 0 && dn.assertOptions(t, {
    silentJSONParsing: K.transitional(K.boolean),
    forcedJSONParsing: K.transitional(K.boolean),
    clarifyTimeoutError: K.transitional(K.boolean)
  }, !1);
  var e = [], o = !0;
  this.interceptors.request.forEach(function(p) {
    typeof p.runWhen == "function" && p.runWhen(r) === !1 || (o = o && p.synchronous, e.unshift(p.fulfilled, p.rejected));
  });
  var a = [];
  this.interceptors.response.forEach(function(p) {
    a.push(p.fulfilled, p.rejected);
  });
  var i;
  if (!o) {
    var s = [Rt, void 0];
    for (Array.prototype.unshift.apply(s, e), s = s.concat(a), i = Promise.resolve(r); s.length; )
      i = i.then(s.shift(), s.shift());
    return i;
  }
  for (var u = r; e.length; ) {
    var l = e.shift(), f = e.shift();
    try {
      u = l(u);
    } catch (c) {
      f(c);
      break;
    }
  }
  try {
    i = Rt(u);
  } catch (c) {
    return Promise.reject(c);
  }
  for (; a.length; )
    i = i.then(a.shift(), a.shift());
  return i;
};
W.prototype.getUri = function(r) {
  return r = se(this.defaults, r), bo(r.url, r.params, r.paramsSerializer).replace(/^\?/, "");
};
fn.forEach(["delete", "get", "head", "options"], function(r) {
  W.prototype[r] = function(t, e) {
    return this.request(se(e || {}, {
      method: r,
      url: t,
      data: (e || {}).data
    }));
  };
});
fn.forEach(["post", "put", "patch"], function(r) {
  W.prototype[r] = function(t, e, o) {
    return this.request(se(o || {}, {
      method: r,
      url: t,
      data: e
    }));
  };
});
var _o = W, Ie, Tt;
function Oo() {
  if (Tt)
    return Ie;
  Tt = 1;
  var n = ae();
  function r(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    var e;
    this.promise = new Promise(function(i) {
      e = i;
    });
    var o = this;
    this.promise.then(function(a) {
      if (o._listeners) {
        var i, s = o._listeners.length;
        for (i = 0; i < s; i++)
          o._listeners[i](a);
        o._listeners = null;
      }
    }), this.promise.then = function(a) {
      var i, s = new Promise(function(u) {
        o.subscribe(u), i = u;
      }).then(a);
      return s.cancel = function() {
        o.unsubscribe(i);
      }, s;
    }, t(function(i) {
      o.reason || (o.reason = new n(i), e(o.reason));
    });
  }
  return r.prototype.throwIfRequested = function() {
    if (this.reason)
      throw this.reason;
  }, r.prototype.subscribe = function(e) {
    if (this.reason) {
      e(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(e) : this._listeners = [e];
  }, r.prototype.unsubscribe = function(e) {
    if (this._listeners) {
      var o = this._listeners.indexOf(e);
      o !== -1 && this._listeners.splice(o, 1);
    }
  }, r.source = function() {
    var e, o = new r(function(i) {
      e = i;
    });
    return {
      token: o,
      cancel: e
    };
  }, Ie = r, Ie;
}
var Ue, jt;
function Eo() {
  return jt || (jt = 1, Ue = function(r) {
    return function(e) {
      return r.apply(null, e);
    };
  }), Ue;
}
var Fe, At;
function wo() {
  return At || (At = 1, Fe = function(r) {
    return typeof r == "object" && r.isAxiosError === !0;
  }), Fe;
}
var Dt = U, xo = tn, ee = _o, Co = un, So = ie();
function pn(n) {
  var r = new ee(n), t = xo(ee.prototype.request, r);
  return Dt.extend(t, ee.prototype, r), Dt.extend(t, r), t.create = function(o) {
    return pn(Co(n, o));
  }, t;
}
var A = pn(So);
A.Axios = ee;
A.Cancel = ae();
A.CancelToken = Oo();
A.isCancel = ln();
A.VERSION = cn().version;
A.all = function(r) {
  return Promise.all(r);
};
A.spread = Eo();
A.isAxiosError = wo();
ot.exports = A;
ot.exports.default = A;
var Io = ot.exports, Uo = Io;
const ke = /* @__PURE__ */ mn(Uo);
var Ye = globalThis && globalThis.__assign || function() {
  return Ye = Object.assign || function(n) {
    for (var r, t = 1, e = arguments.length; t < e; t++) {
      r = arguments[t];
      for (var o in r)
        Object.prototype.hasOwnProperty.call(r, o) && (n[o] = r[o]);
    }
    return n;
  }, Ye.apply(this, arguments);
}, Fo = function(n) {
  return (n || []).map(function(r) {
    return Ye({}, r);
  });
}, vn = function(n, r) {
  r.push(n);
}, ko = function(n, r) {
  n.forEach(function(t) {
    return vn(t, r);
  });
}, Ro = function(n) {
  var r = {};
  return n.forEach(function(t) {
    r[t.uid] ? r[t.uid].push(t) : r[t.uid] = [t];
  }), r;
}, To = function(n) {
  var r = {};
  return le(n, function(t, e) {
    var o = !0;
    t.forEach(function(a) {
      (a.status !== y.Selected || a.validationErrors && a.validationErrors.length > 0) && (o = !1);
    }), o && (r[e] = t);
  }), r;
}, jo = function(n, r) {
  le(n, function(t) {
    t.forEach(function(e) {
      e.status = r;
    });
  });
}, Ao = function(n) {
  var r = [];
  return le(n, function(t) {
    r.push.apply(r, t);
  }), r;
}, le = function(n, r) {
  Object.keys(n).forEach(function(t) {
    r(n[t], t);
  });
};
const E = {
  copyState: Fo,
  addMany: ko,
  add: vn,
  groupFilesByUid: Ro,
  filesForUpload: To,
  setFilesStatus: jo,
  flatFileGroup: Ao,
  groupForEach: le
};
var Qe = globalThis && globalThis.__assign || function() {
  return Qe = Object.assign || function(n) {
    for (var r, t = 1, e = arguments.length; t < e; t++) {
      r = arguments[t];
      for (var o in r)
        Object.prototype.hasOwnProperty.call(r, o) && (n[o] = r[o]);
    }
    return n;
  }, Qe.apply(this, arguments);
}, Do = globalThis && globalThis.__rest || function(n, r) {
  var t = {};
  for (var e in n)
    Object.prototype.hasOwnProperty.call(n, e) && r.indexOf(e) < 0 && (t[e] = n[e]);
  if (n != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, e = Object.getOwnPropertySymbols(n); o < e.length; o++)
      r.indexOf(e[o]) < 0 && Object.prototype.propertyIsEnumerable.call(n, e[o]) && (t[e[o]] = n[e[o]]);
  return t;
}, lt = function(n, r) {
  Object.keys(r).forEach(function(t) {
    n.append(t, r[t]);
  });
}, Po = function(n, r, t) {
  var e = new FormData();
  return lt(e, t), n.forEach(function(o) {
    var a = o.getRawFile ? o.getRawFile() : "";
    a ? e.append(r, a, o.name) : e.append(r, a);
  }), e;
}, Mo = function(n, r, t) {
  var e = new FormData();
  return lt(e, t), n.forEach(function(o) {
    e.append(r, o);
  }), e;
}, No = function(n, r) {
  return {
    headers: n,
    responseType: r.responseType,
    withCredentials: r.withCredentials
  };
}, Bo = function(n) {
  var r = {};
  return Object.keys(n).forEach(function(t) {
    r[t] = n[t];
  }), r;
}, Lo = function(n) {
  var r = n.data;
  n.config;
  var t = Do(n, ["data", "config"]);
  return Qe({ response: r }, t);
};
const R = {
  populateClientFormData: lt,
  populateUploadFormData: Po,
  populateRemoveFormData: Mo,
  populateRequestOptions: No,
  cloneRequestHeaders: Bo,
  convertAxiosResponse: Lo
};
var Pt = "invalidMaxFileSize", Mt = "invalidMinFileSize", Nt = "invalidFileExtension", qo = function(n, r) {
  r.length > 0 && r.indexOf((n.extension || "").toLowerCase()) < 0 && (n.validationErrors = n.validationErrors || [], n.validationErrors.indexOf(Nt) < 0 && n.validationErrors.push(Nt));
}, zo = function(n, r, t) {
  r !== 0 && (n.size || 0) < r && (n.validationErrors = n.validationErrors || [], n.validationErrors.indexOf(Mt) < 0 && n.validationErrors.push(Mt)), t !== 0 && (n.size || 0) > t && (n.validationErrors = n.validationErrors || [], n.validationErrors.indexOf(Pt) < 0 && n.validationErrors.push(Pt));
}, $o = function(n) {
  var r = n.map(function(t) {
    var e = t.substring(0, 1) === "." ? t : "." + t;
    return e.toLowerCase();
  });
  return r;
}, Ho = function(n, r) {
  var t = $o(r.allowedExtensions || []), e = r.maxFileSize || 0, o = r.minFileSize || 0, a;
  for (a = 0; a < n.length; a++)
    qo(n[a], t), zo(n[a], o, e);
};
const Vo = {
  validateFiles: Ho
};
var Ko = {
  name: "@progress/kendo-react-upload",
  productName: "KendoReact",
  productCodes: ["KENDOUIREACT", "KENDOUICOMPLETE"],
  publishDate: 1695802948,
  version: "",
  licensingDocsUrl: "https://www.telerik.com/kendo-react-ui/my-license/?utm_medium=product&utm_source=kendoreact&utm_campaign=kendo-ui-react-purchase-license-keys-warning"
}, Go = globalThis && globalThis.__extends || function() {
  var n = function(r, t) {
    return n = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, o) {
      e.__proto__ = o;
    } || function(e, o) {
      for (var a in o)
        Object.prototype.hasOwnProperty.call(o, a) && (e[a] = o[a]);
    }, n(r, t);
  };
  return function(r, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    n(r, t);
    function e() {
      this.constructor = r;
    }
    r.prototype = t === null ? Object.create(t) : (e.prototype = t.prototype, new e());
  };
}(), G = globalThis && globalThis.__assign || function() {
  return G = Object.assign || function(n) {
    for (var r, t = 1, e = arguments.length; t < e; t++) {
      r = arguments[t];
      for (var o in r)
        Object.prototype.hasOwnProperty.call(r, o) && (n[o] = r[o]);
    }
    return n;
  }, G.apply(this, arguments);
}, Jo = globalThis && globalThis.__rest || function(n, r) {
  var t = {};
  for (var e in n)
    Object.prototype.hasOwnProperty.call(n, e) && r.indexOf(e) < 0 && (t[e] = n[e]);
  if (n != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, e = Object.getOwnPropertySymbols(n); o < e.length; o++)
      r.indexOf(e[o]) < 0 && Object.prototype.propertyIsEnumerable.call(n, e[o]) && (t[e[o]] = n[e[o]]);
  return t;
}, ta = (
  /** @class */
  function(n) {
    Go(r, n);
    function r(t) {
      var e = n.call(this, t) || this;
      return e._httpSubscriptions = {}, e._uploadNavigation = null, e.focus = function() {
        e._uploadNavigation && e._uploadNavigation.focus();
      }, e.triggerUpload = function() {
        e.onUpload();
      }, e.uploadFiles = function(o) {
        var a = e.async;
        E.setFilesStatus(o, y.Uploading), E.groupForEach(o, function(i, s) {
          var u = R.cloneRequestHeaders(a.saveHeaders || {}), l = {}, f = {
            target: e,
            files: i,
            headers: u,
            additionalData: l
          };
          e.props.onBeforeUpload && e.props.onBeforeUpload.call(void 0, f);
          var c = R.populateRequestOptions(f.headers, e.async), p = R.populateUploadFormData(i, a.saveField, f.additionalData);
          if (e.isCustomSave)
            e.props.saveUrl(i, { formData: p, requestOptions: c }, e.onUploadProgress).then(function(m) {
              return e.onUploadSuccess(m.uid);
            }).catch(function(m) {
              return e.onUploadError(m.uid);
            });
          else {
            var h = ke.CancelToken.source();
            e._httpSubscriptions[s] = h, ke(G(G({ method: a.saveMethod, url: a.saveUrl, data: p, cancelToken: h.token }, c), { onUploadProgress: function(m) {
              return e.onUploadProgress(s, m);
            } })).then(function(m) {
              return e.onUploadSuccess(s, m);
            }).catch(function(m) {
              return e.onUploadError(s, m);
            });
          }
        });
      }, e.removeFiles = function(o) {
        var a = e.async;
        E.groupForEach(o, function(i, s) {
          var u = R.cloneRequestHeaders(a.removeHeaders || {}), l = {}, f = {
            target: e,
            files: i,
            headers: u,
            additionalData: l
          };
          e.props.onBeforeRemove && e.props.onBeforeRemove.call(void 0, f);
          var c = i.map(function(m) {
            return m.name;
          }), p = R.populateRequestOptions(f.headers, e.async), h = R.populateRemoveFormData(c, a.removeField, f.additionalData);
          e.isCustomRemove ? e.props.removeUrl(i, { formData: h, requestOptions: p }).then(function(m) {
            return e.onRemoveSuccess(m.uid);
          }).catch(function(m) {
            return e.onRemoveError(m.uid);
          }) : ke(G({ method: a.removeMethod, url: a.removeUrl, data: h }, p)).then(function(m) {
            return e.onRemoveSuccess(s, m);
          }).catch(function(m) {
            return e.onRemoveError(s, m);
          });
        });
      }, e.onUpload = function() {
        var o = e.fileStateCopy, a = E.groupFilesByUid(o), i = E.filesForUpload(a);
        e.uploadFiles(i);
        var s = function() {
          if (e.props.onStatusChange) {
            var u = {
              target: e,
              newState: o,
              affectedFiles: E.flatFileGroup(i)
            };
            e.props.onStatusChange.call(void 0, u);
          }
        };
        e.isControlled ? s() : e.setState({ files: o }, s);
      }, e.onAdd = function(o) {
        var a = T.getAllFileInfo(o), i;
        if (a = T.assignGuidToFiles(a, e.async.batch), Vo.validateFiles(a, e.props.restrictions), e.props.multiple ? i = e.fileStateCopy : i = [], E.addMany(a, i), e.async.autoUpload) {
          var s = E.groupFilesByUid(i);
          e.uploadFiles(E.filesForUpload(s));
        }
        var u = function() {
          if (e.props.onAdd) {
            var l = {
              target: e,
              newState: i,
              affectedFiles: a
            };
            e.props.onAdd.call(void 0, l);
          }
        };
        e.isControlled ? u() : e.setState({ files: i }, u);
      }, e.onUploadProgress = function(o, a) {
        var i = Math.round(100 * a.loaded / a.total) || 0, s = e.fileStateCopy, u = s.filter(function(f) {
          return f.uid === o;
        });
        if (u.length) {
          u.forEach(function(f) {
            f.progress = i;
          });
          var l = function() {
            if (e.props.onProgress) {
              var f = {
                target: e,
                newState: s,
                affectedFiles: u
              };
              e.props.onProgress.call(void 0, f);
            }
          };
          e.isControlled ? l() : e.setState({ files: s }, l);
        }
      }, e.onUploadSuccess = function(o, a) {
        var i = e.fileStateCopy, s = i.filter(function(l) {
          return l.uid === o;
        });
        s.forEach(function(l) {
          l.status = y.Uploaded;
        }), delete e._httpSubscriptions[o];
        var u = function() {
          if (e.props.onStatusChange) {
            var l = {
              target: e,
              newState: i,
              affectedFiles: s,
              response: a ? R.convertAxiosResponse(a) : void 0
            };
            e.props.onStatusChange.call(void 0, l);
          }
        };
        e.isControlled ? u() : e.setState({ files: i }, u);
      }, e.onUploadError = function(o, a) {
        var i = e.fileStateCopy, s = i.filter(function(l) {
          return l.uid === o;
        });
        if (s.forEach(function(l) {
          l.status = y.UploadFailed;
        }), delete e._httpSubscriptions[o], !!s.length) {
          var u = function() {
            if (e.props.onStatusChange) {
              var l = {
                target: e,
                newState: i,
                affectedFiles: s,
                response: a ? R.convertAxiosResponse(a) : void 0
              };
              e.props.onStatusChange.call(void 0, l);
            }
          };
          e.isControlled ? u() : e.setState({ files: i }, u);
        }
      }, e.onRemove = function(o) {
        var a, i = e.fileStateCopy, s = i.filter(function(h) {
          return h.uid === o;
        }), u = i.filter(function(h) {
          return h.uid !== o;
        }), l = [
          y.Uploaded,
          y.Initial,
          y.RemoveFailed
        ];
        if (l.indexOf(s[0].status) > -1) {
          var f = (a = {}, a[o] = s, a);
          E.setFilesStatus(f, y.Removing), e.removeFiles(f);
          var c = function() {
            if (e.props.onStatusChange) {
              var h = {
                target: e,
                newState: i,
                affectedFiles: s
              };
              e.props.onStatusChange.call(void 0, h);
            }
          };
          e.isControlled ? c() : e.setState({ files: i }, c);
        } else {
          var p = function() {
            if (e.props.onRemove) {
              var h = {
                target: e,
                newState: u,
                affectedFiles: s
              };
              e.props.onRemove.call(void 0, h);
            }
          };
          e.isControlled ? p() : e.setState({ files: u }, p);
        }
      }, e.onRemoveSuccess = function(o, a) {
        var i = e.fileStateCopy, s = i.filter(function(f) {
          return f.uid === o;
        }), u = i.filter(function(f) {
          return f.uid !== o;
        }), l = function() {
          if (e.props.onRemove) {
            var f = {
              target: e,
              newState: u,
              affectedFiles: s,
              response: a ? R.convertAxiosResponse(a) : void 0
            };
            e.props.onRemove.call(void 0, f);
          }
        };
        e.isControlled ? l() : e.setState({ files: u }, l);
      }, e.onRemoveError = function(o, a) {
        var i = e.fileStateCopy, s = i.filter(function(l) {
          return l.uid === o;
        });
        s.forEach(function(l) {
          l.status = y.RemoveFailed;
        });
        var u = function() {
          if (e.props.onStatusChange) {
            var l = {
              target: e,
              newState: i,
              affectedFiles: s,
              response: a ? R.convertAxiosResponse(a) : void 0
            };
            e.props.onStatusChange.call(void 0, l);
          }
        };
        e.isControlled ? u() : e.setState({ files: i }, u);
      }, e.onRetry = function(o) {
        var a = e.fileStateCopy, i = E.groupFilesByUid(a.filter(function(u) {
          return u.uid === o;
        }));
        E.setFilesStatus(i, y.Uploading), e.uploadFiles(i);
        var s = function() {
          if (e.props.onStatusChange) {
            var u = {
              target: e,
              newState: a,
              affectedFiles: E.flatFileGroup(i)
            };
            e.props.onStatusChange.call(void 0, u);
          }
        };
        e.isControlled ? s() : e.setState({ files: a }, s);
      }, e.onCancel = function(o) {
        var a = e.fileStateCopy, i = a.filter(function(f) {
          return f.uid !== o;
        }), s = a.filter(function(f) {
          return f.uid === o;
        });
        if (e._httpSubscriptions[o] && (e._httpSubscriptions[o].cancel(), delete e._httpSubscriptions[o]), e.props.onCancel) {
          var u = {
            target: e,
            uid: o
          };
          e.props.onCancel.call(void 0, u);
        }
        var l = function() {
          if (e.props.onRemove) {
            var f = {
              target: e,
              newState: i,
              affectedFiles: s
            };
            e.props.onRemove.call(void 0, f);
          }
        };
        e.isControlled ? l() : e.setState({ files: i }, l);
      }, e.onClear = function() {
        if (e.files.length) {
          Object.keys(e._httpSubscriptions).forEach(function(a) {
            e._httpSubscriptions[a].cancel();
          }), e._httpSubscriptions = {};
          var o = function() {
            if (e.props.onRemove) {
              var a = {
                target: e,
                newState: [],
                affectedFiles: e.fileStateCopy
              };
              e.props.onRemove.call(void 0, a);
            }
          };
          e.isControlled ? o() : e.setState({ files: [] }, o);
        }
      }, qn(Ko), e.state = {
        files: t.defaultFiles || []
      }, e;
    }
    return Object.defineProperty(r.prototype, "async", {
      get: function() {
        var t = this.props, e = t.autoUpload, o = t.batch, a = t.removeField, i = t.removeHeaders, s = t.removeMethod, u = t.removeUrl, l = t.responseType, f = t.saveField, c = t.saveHeaders, p = t.saveMethod, h = t.saveUrl, m = t.withCredentials;
        return {
          autoUpload: e,
          batch: o,
          removeField: a,
          removeHeaders: i,
          removeMethod: s,
          removeUrl: u,
          responseType: l,
          saveField: f,
          saveHeaders: c,
          saveMethod: p,
          saveUrl: h,
          withCredentials: m
        };
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "files", {
      get: function() {
        var t = this.isControlled ? this.props.files : this.state.files;
        return t || [];
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "isControlled", {
      get: function() {
        return !this.props.defaultFiles;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "isCustomSave", {
      get: function() {
        return this.props.saveUrl && typeof this.props.saveUrl == "function";
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "isCustomRemove", {
      get: function() {
        return this.props.removeUrl && typeof this.props.removeUrl == "function";
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "fileStateCopy", {
      get: function() {
        return this.isControlled ? E.copyState(this.props.files) : E.copyState(this.state.files);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "actionElement", {
      /**
       * @hidden
       */
      get: function() {
        if (this._uploadNavigation)
          return this._uploadNavigation.actionElement;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.render = function() {
      var t = this, e = this.props, o = e.showFileList;
      e.onAdd, e.onRemove, e.onCancel;
      var a = e.autoUpload, i = e.showActionButtons, s = e.actionsLayout, u = e.tabIndex, l = e.disabled, f = Jo(e, ["showFileList", "onAdd", "onRemove", "onCancel", "autoUpload", "showActionButtons", "actionsLayout", "tabIndex", "disabled"]), c = E.groupFilesByUid(this.files), p = E.filesForUpload(c);
      return d.createElement(Ar, G({ groupedFiles: c, className: this.props.className, showFileList: o && !!Object.keys(c).length, showActionButtons: i && !a && !!Object.keys(p).length, actionsLayout: s, autoUpload: a, disabled: l, onAdd: this.onAdd, onRemove: this.onRemove, onClear: this.onClear, onUpload: this.onUpload, onRetry: this.onRetry, onCancel: this.onCancel, tabIndex: Ln(u, l), ref: function(h) {
        return t._uploadNavigation = h;
      } }, f));
    }, r.defaultProps = {
      autoUpload: !0,
      batch: !1,
      removeField: "fileNames",
      removeHeaders: {},
      removeMethod: "POST",
      removeUrl: "",
      responseType: "json",
      saveField: "files",
      saveHeaders: {},
      saveMethod: "POST",
      saveUrl: "",
      withCredentials: !0,
      restrictions: {
        allowedExtensions: [],
        maxFileSize: 0,
        minFileSize: 0
      },
      multiple: !0,
      showFileList: !0,
      showActionButtons: !0,
      actionsLayout: "end",
      disabled: !1
    }, r.propTypes = {
      autoUpload: v.bool,
      batch: v.bool,
      withCredentials: v.bool,
      saveField: v.string,
      saveHeaders: v.object,
      saveMethod: v.string,
      saveUrl: v.oneOfType([v.string, v.func]),
      responseType: v.oneOf(["arraybuffer", "blob", "json", "text"]),
      removeField: v.string,
      removeHeaders: v.object,
      removeMethod: v.string,
      removeUrl: v.oneOfType([v.string, v.func]),
      multiple: v.bool,
      disabled: v.bool,
      showFileList: v.bool,
      showActionButtons: v.bool,
      actionsLayout: v.oneOf(["start", "center", "end", "stretched"]),
      tabIndex: v.number,
      accept: v.string,
      listItemUI: v.oneOfType([
        v.func,
        v.string,
        v.shape({ render: v.func.isRequired })
      ]),
      restrictions: v.shape({
        allowedExtensions: v.arrayOf(v.string),
        maxFileSize: v.number,
        minFileSize: v.number
      }),
      files: v.arrayOf(v.shape({
        uid: v.string,
        name: v.string,
        extension: v.string,
        size: v.number,
        validationErrors: v.arrayOf(v.string),
        status: v.oneOf([
          y.Initial,
          y.RemoveFailed,
          y.Removing,
          y.Selected,
          y.UploadFailed,
          y.Uploaded,
          y.Uploading
        ]),
        progress: v.number,
        getRawFile: v.func
      })),
      defaultFiles: v.arrayOf(v.shape({
        uid: v.string,
        name: v.string,
        extension: v.string,
        size: v.number,
        validationErrors: v.arrayOf(v.string),
        status: v.oneOf([
          y.Initial,
          y.RemoveFailed,
          y.Removing,
          y.Selected,
          y.UploadFailed,
          y.Uploaded,
          y.Uploading
        ]),
        progress: v.number,
        getRawFile: v.func
      }))
    }, r;
  }(d.Component)
);
export {
  re as I,
  ta as U,
  Yn as a,
  C as c,
  Wn as d,
  Ln as g,
  _ as m,
  Ko as p,
  Qn as r,
  qn as v
};
